meetingActive.controller('meetingActiveCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$sce',
    '$q',
    '$interval',
    'cookieService',
    'logService',
    'attendeeService',
    'meetingNotesService',
    'customerSupportService',
    'helperService',
    'socketService',
    'meetingService',
    'configService',
    'analyticsWrapperService',
    '$document',
    'onboardingService',
    'capabilityService',
    '$window',
    'vertoService',
    'connectivityService',
    'promptService',
    'contentService',
    'storageService',
    'peerConnectionService',
    'localStreamManagerService',
    'canvasMonitoringService',
    'annotationService',
    'avDeviceService',
    'notificationService',
    'localizationService',
    'brandingService',
    'screenShareService',
    'meetingAPIService',
    'videoroomService',
    'themedFeaturesService',
    'recordingService',
    'vdiService',
    'attendeeListService',
    function (
        $rootScope,
        $scope,
        $timeout,
        $sce,
        $q,
        $interval,
        cookieService,
        logService,
        attendeeService,
        meetingNotesService,
        customerSupportService,
        helperService,
        socketService,
        meetingService,
        configService,
        analyticsWrapperService,
        $document,
        onboardingService,
        capabilityService,
        $window,
        vertoService,
        connectivityService,
        promptService,
        contentService,
        storageService,
        peerConnectionService,
        localStreamManagerService,
        canvasMonitoringService,
        annotationService,
        avDeviceService,
        notificationService,
        localizationService,
        brandingService,
        screenShareService,
        meetingAPIService,
        videoroomService,
        themedFeaturesService,
        recordingService,
        vdiService,
        attendeeListService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'meetingActiveCtrl');

        var colorPickerBounds = null;

        self.isHost = attendeeService.getIsHost(true);
        self.isEdgeBrowser = helperService.isEdgeBrowser();
        self.isIE = helperService.isIE();
        self.isConferenceConnected = isConferenceConnected;
        self.isAndroid = helperService.getDeviceType() === 'Android';
        self.isIOS = helperService.getDevicePlatform() === 'iOS';
        self.isMac = helperService.isMac();

        self.fsConnectionCompleteReceived = false;

        //Hacky way to prevent iPhone X offset until we find better solution
        self.iOSOffsetClass = helperService.getIOSOffsetClass();

        self.getFeedType = getFeedType;

        //Webinar
        self.isWebinar = isWebinar;
        self.isOnAir = isOnAir;
        self.isPresenter = isPresenter;
        self.isWaitingRoomEnabled = isWaitingRoomEnabled;
        self.isGreenRoomEnabled = isGreenRoomEnabled;
        self.isPractice = isPractice;
        self.isWebinarVirtualBlurredBackgroundAvailable =
            meetingService.getIsWebinarVirtualBlurredBackgroundAvailable();

        self.titleBarHeight = 32;
        self.titleBarOffset = meetingService.isTitleBarAvailable() ? self.titleBarHeight : 0;
        self.headerOffset = helperService.getVDIRef().showCustomTitleBar ? self.titleBarHeight : 0;
        self.bodyOffset = 60; //For desktop/tablet, initially set to size of header
        self.mobileBodyOffset = 0;

        // Voting
        self.isVoting = false;
        self._onStartVoting = _onStartVoting;
        self._onStopVoting = _onStopVoting;

        //Q and A
        self.isInQandA = false;
        self._onStartQandA = _onStartQandA;
        self._onStopQandA = _onStopQandA;

        //Recording
        self.isRecording = recordingService.isRecording;
        self._onRecordingEvent = _onRecordingEvent;
        self.updateHeaderMenuStyleWhenFadeOutTimerFired = updateHeaderMenuStyleWhenFadeOutTimerFired;
        self.updateHeaderMenuStyleWhenToggleRecording = updateHeaderMenuStyleWhenToggleRecording;
        self.adjustHeaderMenuPosition = adjustHeaderMenuPosition;

        //Content
        self.isContentPlaying = false;
        self.currentContentOwnerId = 0;
        self.currentContentType = '';
        self._onContentInitiating = _onContentInitiating;
        self._onContentInitCancelled = _onContentInitCancelled;
        self._onContentPlaying = _onContentPlaying;
        self._onContentStopped = _onContentStopped;
        self._onContentStatus = _onContentStatus;
        self.isFeedActive = isFeedActive;
        self.isLoadingPopupOpen = false;

        // multishare user pair related
        self.hasMultishare = configService.getHasMultishare();
        self.isScreenVideo = false;

        // whether to hide mute indicator. prefer query param.
        self.hideMuteIndicator =
            helperService.getQueryParameter('hideMuteIndicator') ||
            JSON.parse(storageService.get('advancedSettings') || '{}').hideMuteIndicator == 'true';

        //Mobile (non-tablet) Chat/Attendee tabs
        self.mobileChatAttendeeTabsVisible = false;
        self.toggleMobileChatAttendeeTabs = toggleMobileChatAttendeeTabs;

        self.onMobileWebinarAttendeeQAPromptVisible = onMobileWebinarAttendeeQAPromptVisible;
        self.mobileWebinarAttendeeQAPromptVisible = false;

        //Mobile + Desktop Marquee
        self.onVideoFeedCountChange = onVideoFeedCountChange;
        self.onScreenVideoCountChange = onScreenVideoCountChange;
        self.videoFeedCount = 0;
        self.screenVideoCount = 0;
        self.initFeedVisibility = initFeedVisibility;

        //custom branding
        self.defaultBackgroundPath = getDefaultBackgroundPath();
        self.inMeetingBackground = meetingService.getBrandingInfo().backgroundURL || self.defaultBackgroundPath;
        self._onBrandInformation = _onBrandInformation;

        self.allowedToTrackAudio = false;
        self.canTrackLocalAudioWhileMuted = canTrackLocalAudioWhileMuted;
        self.trackLocalAudioWhileMuted = trackLocalAudioWhileMuted;
        self.stopTrackingLocalAudio = stopTrackingLocalAudio;
        self.talkingTimeoutWhileMuted = null;
        self.restartTrackLocalAudioWhileMutedTimeout = null;
        self.cancelTalkingTimeoutWhileMuted = cancelTalkingTimeoutWhileMuted;
        self.cancelRestartTrackLocalAudioWhileMutedTimeout = cancelRestartTrackLocalAudioWhileMutedTimeout;

        self.phoneOnlyState = false;

        self.hasSideBar = hasSideBar;

        self.meetingContentShouldBeTransparent = false;
        self.contentShouldBeTransparent = contentShouldBeTransparent;

        self.isInFullScreenMode = false;
        self.isExpanded = false;

        //Mobile Swipe Gestures
        self.onSideBarSwipeLeft = onSideBarSwipeLeft;
        self.onSideBarSwipeRight = onSideBarSwipeRight;

        //HD ScreenShare
        self.isHDScreenShareAvailable = false;
        self.hdScreenShareEventListenersAdded = false;
        self.hdScreenShareAllowed = hdScreenShareAllowed;
        self.shouldShowHDScreenShareFeed = shouldShowHDScreenShareFeed;
        self.isScreenShareActive = isScreenShareActive;
        self.isVideoShareActive = isVideoShareActive;
        self.isScreenShareOwner = isScreenShareOwner;
        self.syncHDVertoMediaTracks = syncHDVertoMediaTracks;
        self.startWaitForHDScreenShareConferenceCall = startWaitForHDScreenShareConferenceCall;
        self.initHDScreenShareEventListeners = initHDScreenShareEventListeners;
        self.setHDScreenShareAvailabilityFlag = setHDScreenShareAvailabilityFlag;

        self.toggleFullScreen = toggleFullScreen;
        self.toggleFullScreenWrapper = toggleFullScreenWrapper;
        self.toggleExpansion = toggleExpansion;
        self.autoHideHeader = autoHideHeader;
        self.isVideoOverlappingHeader = isVideoOverlappingHeader;

        self.singleShareEnabled = false;
        self.singleShareStream = undefined;

        self.isSingleShareFeedPlaying = false;
        self.getStreamElement = getStreamElement;
        self.attachLoadMediaListener = attachLoadMediaListener;
        self.playMedia = playMedia;
        self.stopMedia = stopMedia;
        self.reloadMedia = reloadMedia;
        self.completeMediaPlayMode = completeMediaPlayMode;

        self.onSingleShareEnabled = onSingleShareEnabled;
        self.shouldShowSingleWebcamShareLocalView = shouldShowSingleWebcamShareLocalView;
        self.setupSingleShareView = setupSingleShareView;
        self.setProperOneOnOneStream = setProperOneOnOneStream;
        self.determineLocalTracksAndSetProperStream = determineLocalTracksAndSetProperStream;
        self.updateStreamReference = updateStreamReference;
        self.clearStreamReference = clearStreamReference;

        self.onAnnotationSync = onAnnotationSync;

        self.annotationEnabled = annotationService.getIsAnnotationEnabled;
        self.dynamicVBWEnabled = false;
        self.onDynamicVBWEnabled = onDynamicVBWEnabled;

        self.isScreenShareOnlyConf = meetingService.getMeetingType() === 'screenshare';
        self.isVideoOnlyConf = meetingService.getMeetingType() === 'videoconference';

        self.onBackgroundModeActivated = onBackgroundModeActivated;
        self.onBackgroundModeDeactivated = onBackgroundModeDeactivated;
        self.shouldSetVertoFeedToVisible = shouldSetVertoFeedToVisible;

        self.getIsPermissionOverlayOpen = avDeviceService.getIsPermissionOverlayOpen;

        self.sendTelephoneStateToServer = sendTelephoneStateToServer;
        self.usingAudioThroughPhone = connectivityService.getAudioThroughPhone;

        self.streamTypes = {
            SINGLE_SHARE: 'singleShareStream',
            LOCAL: 'currentStream'
        };

        self.adjustSideBarLeftOffsetBasedOnWidth = adjustSideBarLeftOffsetBasedOnWidth;

        self.sideBarVisibleBeforeFullscreen = true;
        self.headerFadeOutDuration = 3000;
        self.fadeOutHeaderBarTimer = null;
        self.fadeOutTopBottomControlTimer = null;
        self.cancelExistingTopBottomControlFadeOutTimer = cancelExistingTopBottomControlFadeOutTimer;

        self.getShouldShowMessageBanner = getShouldShowMessageBanner;
        self.shouldShowAnnotationButton = false;
        self.getShouldShowAnnotationButton = getShouldShowAnnotationButton;
        self.annotationEnabledLocally = false;
        self.mouseEnteredOnAnnotationButton = false;
        self.toggleUserAnnotation = toggleUserAnnotation;
        self.getPenColor = getPenColor;
        self.getColors = getColors;
        self.showColorPicker = showColorPicker;
        self.hideColorPicker = hideColorPicker;
        self.highlightAnnotationBtn = false;
        self.initAnnotationBtnHighlighting = initAnnotationBtnHighlighting;
        self.showAnnotationLoadingAnimation = false;

        self.getAnnotationStatusTooltip = getAnnotationStatusTooltip;
        self.getIsAnnotationDisabled = getIsAnnotationDisabled;
        self.shouldAllowAnnotationPenButtonInteraction = shouldAllowAnnotationPenButtonInteraction;
        self.isConnecting = isConnecting;
        self.isSFUEnabled = meetingService.getIsSfuEnabled();

        self.showingFeatureFlags = false;

        self.videoRoomWebcamVisible = false;

        self.initCall = initCall;
        self.connectSocket = connectSocket;
        self.determineMicAndCamAvailability = determineMicAndCamAvailability;
        self.broadcastEventToStartCall = broadcastEventToStartCall;
        self.isReceivingOnly = isReceivingOnly;
        self._setDeviceForMeeting = _setDeviceForMeeting;

        //Device Unplugging / Re-plugging  //TODO: figure out if we need to port this or not
        self.onVertoCallAudioInputUpdated = onVertoCallAudioInputUpdated;

        //ported
        self.deviceAvailabilityCheckInterval = null;
        self.onActiveTrackEnded = onActiveTrackEnded;
        self.sendAudioDeviceConnectionStateToServer = sendAudioDeviceConnectionStateToServer;
        self.promptUserAboutDeviceReconnection = promptUserAboutDeviceReconnection;
        self.showDeviceConnectingAlert = showDeviceConnectingAlert;
        self.cancelDeviceAvailabilityCheckInterval = cancelDeviceAvailabilityCheckInterval;
        self.onUserCancelledReconnectionFlow = onUserCancelledReconnectionFlow;
        self.startDeviceAvailabilityCheckInterval = startDeviceAvailabilityCheckInterval;
        self.setSweetAlertBtnDisabledState = setSweetAlertBtnDisabledState;
        self.attemptMediaTrackReconnection = attemptMediaTrackReconnection;
        self.connectToNextAvailableDevice = connectToNextAvailableDevice;
        self.attemptAudioTrackReconnection = attemptAudioTrackReconnection;
        self.attemptVideoTrackReconnection = attemptVideoTrackReconnection;
        self.inProcessDevice = null;
        self.queuedDeviceType = null;
        self.finishReconnectFlow = finishReconnectFlow;

        self.onMuteStateUpdated = onMuteStateUpdated;

        self.onScopeDestroyed = onScopeDestroyed;

        self.onHeaderControlHideState = onHeaderControlHideState;
        self.enableAutoHideHeaderControls = enableAutoHideHeaderControls;
        self.disableAutoHideHeaderControls = disableAutoHideHeaderControls;
        self.mouseMoveHandlerForTopBottomControl = mouseMoveHandlerForTopBottomControl;
        self.autoHideEventListenerEnabled = false;
        self.showingTopBottomControl = false;
        self.autoHideDisabledReasons = {};
        self.onPacketLossState = onPacketLossState;

        self.isDeviceSelectionModalOpen = false;
        self.getIconForMuteIndicator = getIconForMuteIndicator;
        self.isAudioMuted = isAudioMuted;

        self.isLayoutChangeAvailable = isLayoutChangeAvailable;
        self.isLayoutChangeAvailableForLargeGalleryView = isLayoutChangeAvailableForLargeGalleryView;

        self.onWindowResize = onWindowResize;
        self.movePresenterCtrlBtnsToSecondRow = false;
        self.checkSpaceBetweenScreenshareBtns = checkSpaceBetweenScreenshareBtns;

        self.onVisibilityChange = onVisibilityChange;

        self.isLayoutActive = isLayoutActive;
        self.onAWVPaginationHover = onAWVPaginationHover;
        self.enterAWVFromPagination = enterAWVFromPagination;
        self.exitAWVFromPagination = exitAWVFromPagination;
        self.shouldAWVPaginationBounceIn = shouldAWVPaginationBounceIn;
        self.shouldShowAppCues = shouldShowAppCues;
        self.awvPaginationShownOnce = false;
        self.shouldAutoHideAWVPagination = false;
        self.awvPaginationBounceInTimer = null;
        self.showAWVBanner = showAWVBanner;
        self.layoutControls = { enable: false, allhands: false };

        self.canvasBannerHeight = 0;

        self.verticalJoinFlowEnabled = verticalJoinFlowEnabled;
        self.disconnectedMicDevice = null;
        self.disconnectedWebcamDevice = null;
        self.startJoinFlow = startJoinFlow;
        self.setDeviceForConferenceOrScreenShare = setDeviceForConferenceOrScreenShare;
        self.trySetDeviceForMeeting = trySetDeviceForMeeting;
        self.VDIRef = helperService.getVDIRef();
        self.cleanupAnnotationUiForVDI = cleanupAnnotationUiForVDI;

        self.onCompactModeReceived = onCompactModeReceived;
        self.isInCompactMode = false;

        self.disconnectAudio = disconnectAudio;
        self.showNoAudioPromptForRoomConference = showNoAudioPromptForRoomConference;
        self.isAudioDisconnected = avDeviceService.isAudioDisconnected;
        self.getTextForMuteIndicator = getTextForMuteIndicator;

        self.hideAnnotationButton = hideAnnotationButton;
        self.showAnnotationButton = showAnnotationButton;
        self.onAnnotationContinue = onAnnotationContinue;

        $scope.$on('new-user-audio-choice', _newOnUserAudioChoice);

        $scope.$on('toggle-mobile-chat-attendee-tabs', self.toggleMobileChatAttendeeTabs);
        $scope.$on('mobile-webinar-attendee-qa-prompt-visible', self.onMobileWebinarAttendeeQAPromptVisible);
        $scope.$on('video-feed-count', self.onVideoFeedCountChange);
        $scope.$on('screen-video-count', self.onScreenVideoCountChange);

        $scope.$on('voting-started', self._onStartVoting);
        $scope.$on('voting-stopped', self._onStopVoting);

        $scope.$on('start-qa-mode', self._onStartQandA);
        $scope.$on('stop-qa-mode', self._onStopQandA);

        $scope.$on('recording-event', self._onRecordingEvent);

        $scope.$on('content-initiating', self._onContentInitiating);
        $scope.$on('content-init-cancelled', self._onContentInitCancelled);
        $scope.$on('content-playing', self._onContentPlaying);
        $scope.$on('content-stopped', self._onContentStopped);
        $scope.$on('content-status', self._onContentStatus);
        $scope.$on('branding-info-updated', self._onBrandInformation);
        $scope.$on('banner-height-changed', onBannerHeightChanged);
        $scope.$on('canvas-banner-height-changed', onCanvasBannerHeightChanged);
        $scope.$on('loading-popup-started', onLoadingPopupStart);
        $scope.$on('loading-popup-stopped', onLoadingPopupStop);
        $scope.$on('phone-only-state', onPhoneOnlyState);
        $scope.$on('node-reconnected', onNodeReconnected);
        $scope.$on('device-permissions-updated', onDevicePermissionUpdated);
        $scope.$on('user-capability-updated', onUserCapabilityUpdated);
        $scope.$on('change-meeting-content-opacity', onChangeMeetingContentOpacity);
        $scope.$on('webinar-options-updated', onWebinarOptionsUpdated);
        $scope.$on('fs-connection-complete', onFSConnectionComplete);
        $scope.$on('fs-connection-complete-local-check', onFSConnectionComplete);
        $scope.$on('hide-modal', onHideModal);

        $scope.$on('showhide-feature-flags', onShowHideFeatureFlags);

        $scope.$on('screenshare-started', onScreenShareStarted);
        $scope.$on('hd-screenshare-conf-call-connected', onHDScreenShareConfCallConnected);
        $scope.$on('hd-screenshare-conf-call-disconnected', onHDScreenShareConfCallDisconnected);
        $scope.$on('hd-screenshare-fs-connection-complete', onHDScreenShareFSConnectionComplete);
        $scope.$on('screenshare-ended', onScreenShareEnded);

        $scope.$on('sfu-screen-video-state', onSfuScreenVideoState);

        $scope.$on('promoted-to-presenter', onPromotedToPresenter);
        $scope.$on('demoted-to-attendee', onDemotedToAttendee);
        $scope.$on('update-auth-data', onUpdateAuthData);

        $scope.$on('finished-media-device-selection', onFinishedMediaDeviceSelection);
        $scope.$on('established-remote-stream', onEstablishedRemoteStream);
        $scope.$on('destroyed-remote-stream', onDestroyedRemoteStream);

        $scope.$on('sa-on-sync', onAnnotationSync);

        $scope.$on('verto-ice-connection-completed', onVertoCallCompleted);
        $scope.$on('update-meeting-active-feed', onUpdateMeetingActiveFeed);
        $scope.$on('dynamic-vbw-enabled', onDynamicVBWEnabled);

        $scope.$on('annotation-color-changed', onAnnotationColorChanged);
        $scope.$on('annotation-in-session', onAnnotationSessionState);
        $scope.$on('annotation-connection-failed', onAnnotationConnectionFailed);

        $scope.$on('video-room-webcams-visible', onVideoRoomWebcamsVisible);

        $scope.$on('phone-state-updated', onPhoneStateUpdated);

        $scope.$on('cloned-audio-stream-ready', onClonedAudioStreamReady);
        $scope.$on('cloned-audio-track-ended', onClonedAudioTrackEnded);
        $scope.$on('update-local-audio-state', onUpdateLocalAudioState);

        //ported event from conference controller
        $scope.$on('active-track-ended', self.onActiveTrackEnded);
        $scope.$on('verto-call-audio-input-updated', self.onVertoCallAudioInputUpdated);

        $scope.$on('mute-state-updated', self.onMuteStateUpdated);

        $scope.$on('$destroy', self.onScopeDestroyed);

        $scope.$on('enable-header-auto-hide', self.onHeaderControlHideState);
        $scope.$on('packet-loss-state', self.onPacketLossState);

        $scope.$on('track-local-audio-while-muted', self.trackLocalAudioWhileMuted);
        $scope.$on('stop-tracking-local-audio', self.stopTrackingLocalAudio);

        $scope.$on('layout-changed', onLayoutChanged);

        $scope.$on('videoroom-layout-controls', onLayoutChangeControls);

        $scope.$on('enable-compact-mode', self.onCompactModeReceived);

        $scope.$on('add-attendee', onAddAttendee);

        $scope.$on('sa-continue', self.onAnnotationContinue);

        $document.on(
            'webkitfullscreenchange mozfullscreenchange msfullscreenchange fullscreenchange',
            onFullScreenChange
        );

        self.isThemedFeaturesEnabled = isThemedFeaturesEnabled;
        self.onThemedFeaturesToggled = onThemedFeaturesToggled;
        self.checkForThemedVBG = checkForThemedVBG;
        $scope.$on('themed-features-toggled', self.onThemedFeaturesToggled);

        init();

        ////////////////////////

        //This used to disable the header autohide settings if there was packet loss
        //This Function can be useful if something needs to be done with the packetloss icon
        function onPacketLossState(ev, data) {
            if (!helperService.getIsRedesign()) {
                return;
            }
        }

        function getIsAnnotationDisabled() {
            return annotationService.getSharerSupportsAnnotation() === false || annotationService.getIsSuspended();
        }

        function hideAnnotationButton() {
            self.shouldShowAnnotationButton = false;
            const annotationButton = $window.$('#annotation-button')[0];
            if (annotationButton) {
                const bounds = annotationButton.getBoundingClientRect();
                helperService.getVDIRef().removeClipRect(bounds);
            }
            annotationService.cleanupAnnotationUiForVDI();
        }

        function showAnnotationButton() {
            self.shouldShowAnnotationButton = true;
        }

        function getAnnotationStatusTooltip() {
            if (annotationService.isPenDragEnabled()) {
                return '';
            }
            if (annotationService.getSharerSupportsAnnotation() == false) {
                if (contentService.getIsSharingAppScreen() && contentService.getScreenShareHostType() === 'electron') {
                    return localizationService.translate(
                        'ANNOTATION.TOOLTIP.SA_NOT_AVAILABLE_AS_PRESENTER_IS_SHARING_APP'
                    );
                } else {
                    return localizationService.translate(
                        'ANNOTATION.TOOLTIP.SA_NOT_AVAILABLE_AS_PRESENTER_NOT_USING_SUPPORTED_APP_VERSION'
                    );
                }
            } else if (annotationService.getIsSuspended()) {
                return localizationService.translate('ANNOTATION.TOOLTIP.SA_HAS_BEEN_DISABLED_BY_PRESENTER');
            }

            switch (annotationService.getConnectivitystate()) {
                case annotationService.connectivityStateType.connecting:
                    return localizationService.translate('ANNOTATION.TOOLTIP.SA_WILL_BE_AVAILABLE_MOMENTARILY');
                case annotationService.connectivityStateType.reconnecting:
                    return localizationService.translate('ANNOTATION.TOOLTIP.SA_WILL_BE_AVAILABLE_MOMENTARILY');
                case annotationService.connectivityStateType.unrequestedDisconnect:
                    return localizationService.translate('ANNOTATION.TOOLTIP.SA_CURRENTLY_UNAVAILABLE');
                case annotationService.connectivityStateType.disconnected:
                    return localizationService.translate('ANNOTATION.TOOLTIP.SA_CLICK_TO_TURN_ANNOTATION_ON_AND_OFF');
                default:
                    return '';
            }
        }

        function onAnnotationConnectionFailed(e) {
            if (!annotationService.getIsInitiator()) {
                self.annotationEnabledLocally = false;
            }
        }

        function onAnnotationSessionState(e, inSession) {
            if (inSession) {
                self.showAnnotationButton();
            } else {
                self.hideColorPicker();
            }

            if (!annotationService.getIsInitiator()) {
                canvasMonitoringService.setAnnotationInSession(inSession);
                self.syncHDVertoMediaTracks();
                digest();
            }
        }

        function onScopeDestroyed() {
            self.cancelDeviceAvailabilityCheckInterval();
            avDeviceService.removeDeviceChangeListener();
        }

        function initAnnotationBtnHighlighting() {
            var annotationBtn = $window.$('#annotation-button');

            if (annotationBtn) {
                annotationBtn.addClass('bounceIn');
                annotationBtn.on('animationend', onAnnotationBtnAnimationEnd);
            }

            function onAnnotationBtnAnimationEnd() {
                if (annotationBtn) {
                    annotationBtn.off('animationend', onAnnotationBtnAnimationEnd);
                    annotationBtn.removeClass('bounceIn');
                }

                $timeout(function () {
                    self.highlightAnnotationBtn = true;

                    //Each animated 'bounce' lasts 1.5s
                    //We want 3 bounces, so timeout is 1.5s x 3
                    $timeout(function () {
                        self.highlightAnnotationBtn = false;
                    }, 4500);
                }, 1000);
            }
        }

        function toggleUserAnnotation() {
            if (annotationService.isPenDragEnabled()) {
                return;
            }
            if (!self.shouldAllowAnnotationPenButtonInteraction()) {
                return;
            }
            self.annotationEnabledLocally = !self.annotationEnabledLocally;
            self.highlightAnnotationBtn = false;
            annotationService.setIsLocalAnnotationEnabled(self.annotationEnabledLocally);
            if (self.annotationEnabledLocally) {
                annotationService.requestConnection();
            } else {
                if (meetingService.getIsSfuEnabled()) {
                    annotationService.removeListeners();
                }
                annotationService.disconnect();
            }

            $rootScope.$broadcast('toggled-annotation', self.annotationEnabledLocally);

            analyticsWrapperService.eventTrack(
                'Meeting - Annotation - User turns ' + (self.annotationEnabledLocally ? 'on' : 'off') + ' annotation',
                {
                    category: 'Annotation',
                    attendee: attendeeService.getEmail()
                }
            );

            if (!meetingService.getIsSfuEnabled() && self.annotationEnabledLocally && !self.isHDScreenShareAvailable) {
                self.startWaitForHDScreenShareConferenceCall('User enabled annotation');
                self.showAnnotationLoadingAnimation = true;
            }
            self.syncHDVertoMediaTracks();
            digest();
        }

        function getShouldShowMessageBanner() {
            return !helperService.isVideoRoomApplication();
        }

        function getShouldShowAnnotationButton() {
            if (
                helperService.isMobile() ||
                helperService.isTablet() ||
                helperService.isVideoRoomApplication() ||
                !self.shouldShowAnnotationButton
            ) {
                return false;
            }

            if (meetingService.getIsSfuEnabled()) {
                if (contentService.getIsHostingSFUScreenShare() && !self.isScreenVideo) {
                    return false;
                }
                let shouldShow =
                    !meetingService.isWebinar() &&
                    self.isScreenShareActive() &&
                    annotationService.isScreenShareFeedPlaying();
                if (!self.VDIRef.showContentsOnTopOfVideo && shouldShow) {
                    annotationService.showAnnotationButtonOnTopVDI();
                }
                return shouldShow;
            }
            return !meetingService.isWebinar() && self.isScreenShareActive() && self.isHDScreenShareAvailable;
        }

        function shouldAllowAnnotationPenButtonInteraction() {
            if (!annotationService.getSharerSupportsAnnotation() || annotationService.getIsSuspended()) {
                return false;
            }

            switch (annotationService.getConnectivitystate()) {
                case annotationService.connectivityStateType.connecting:
                case annotationService.connectivityStateType.reconnecting:
                case annotationService.connectivityStateType.unrequestedDisconnect:
                    return false;
                default:
                    return true;
            }
        }

        function isConnecting() {
            switch (annotationService.getConnectivitystate()) {
                case annotationService.connectivityStateType.connecting:
                case annotationService.connectivityStateType.reconnecting:
                    return true;
                default:
                    return false;
            }
        }

        function getPenColor() {
            return annotationService.getPenColor();
        }

        function getColors() {
            return annotationService.getColors();
        }

        function showColorPicker() {
            self.mouseEnteredOnAnnotationButton = true;
            var colorPickerElement = $window.$('#annotation-color-picker');
            var annotationBtn = $window.$('#annotation-button');
            colorPickerElement.toggleClass('am-bottom', annotationBtn.offset().top < 320);
            colorPickerElement.toggleClass('am-top', annotationBtn.offset().top >= 320);
            colorPickerElement.addClass('show-color-picker');
            let newBounds = colorPickerElement.get(0).getBoundingClientRect();
            if (colorPickerBounds !== null) {
                self.VDIRef.removeClipRect(colorPickerBounds);
            }
            self.VDIRef.addClipRect(newBounds);
            colorPickerBounds = newBounds;
        }

        function hideColorPicker(msDelay = 0) {
            self.mouseEnteredOnAnnotationButton = false;
            setTimeout(() => {
                if (!self.mouseEnteredOnAnnotationButton) {
                    var colorPickerElement = $window.$('#annotation-color-picker');
                    if (colorPickerElement.get(0)) {
                        colorPickerElement.removeClass('show-color-picker');
                        if (colorPickerBounds) {
                            self.VDIRef.removeClipRect(colorPickerBounds);
                            colorPickerBounds = null;
                        }
                    }
                }
            }, msDelay);
        }

        function onAnnotationColorChanged(e, color) {
            digest();
        }

        function onFinishedMediaDeviceSelection(e, data) {
            if (data && (data.newVideoInputDeviceSelected || data.newAudioInputDeviceSelected)) {
                //If newer version of Chrome or Electron, the proper streams
                //
                //Otherwise, we manually re-initiate those streams

                if (localStreamManagerService.shouldUseDeprecatedSpecForStreams()) {
                    if (self.shouldShowSingleWebcamShareLocalView()) {
                        localStreamManagerService.stopLocalVideoTrack();
                        self.stopMedia(self.streamTypes.SINGLE_SHARE);

                        $timeout(function () {
                            self.setupSingleShareView();
                        }, 3000);
                    }
                }
            }
        }

        function onEstablishedRemoteStream() {
            self.determineLocalTracksAndSetProperStream();
        }

        function onDestroyedRemoteStream() {
            self.stopMedia(self.streamTypes.LOCAL);
            digest();
        }

        function init() {
            if (helperService.getIsRedesign()) {
                self.bodyOffset = 0;
            }

            if (!self.VDIRef.showContentsOnTopOfVideo) {
                self.autoHideDisabledReasons['VDI'] = true;
                self.disableAutoHideHeaderControls();
            }

            logService.log('Adding visibility event listener');
            if ($document[0]) {
                if (typeof $document[0].hidden !== 'undefined') {
                    $document.on('visibilitychange', self.onVisibilityChange);
                } else if (typeof $document[0].webkitHidden !== 'undefined') {
                    $document.on('webkitvisibilitychange', self.onVisibilityChange);
                }
            }

            analyticsWrapperService.startAttendanceTimer();

            if (attendeeService.getIsHost()) {
                analyticsWrapperService.startHostMeetingDurationTimer();
            }

            if (meetingService.getEnableOracleLiveChat()) {
                customerSupportService.initODAChatWidget();
            } else {
                customerSupportService.enableSnapEngageLiveSupportWidget();
            }

            if (helperService.isMobile() && !helperService.isTablet()) {
                //This is normally called in contentLibraryModalCtrl...
                //iPhone doesn't include that modal, so we will manually retrieve content status here.
                socketService.send({
                    message: 'retrieve-content-status',
                    data: {}
                });
            }

            meetingNotesService.init();

            socketService.send({
                message: 'video-feed-count',
                data: {},
                callback: (e, count) => {
                    self.onVideoFeedCountChange(e, count);
                    $rootScope.$broadcast('init-video-feed-count', count);
                }
            });

            if (self.hasMultishare) {
                socketService.send({
                    message: 'screen-video-count',
                    data: {},
                    callback: self.onScreenVideoCountChange
                });
            }

            socketService.send({
                message: 'single-share-enabled',
                data: {},
                callback: self.onSingleShareEnabled
            });

            socketService.send({
                message: 'dynamic-vbw-enabled',
                data: {},
                callback: function (data) {
                    self.onDynamicVBWEnabled('', data);
                }
            });

            var title = meetingService.getTitle() + ' | ' + meetingService.getCompanyName();
            $document[0].title = title;

            var shouldExpand =
                meetingService.getMeetingType() === 'videoconference' ? true : storageService.get('shouldExpand');

            if (meetingService.getIsSfuEnabled()) {
                shouldExpand = true;
            }

            self.isExpanded = shouldExpand === 'true' || shouldExpand === true ? true : false;
            canvasMonitoringService.setExpandedState(self.isExpanded);

            trackViewing();

            if (helperService.isMobile()) {
                $window.cordova.plugins.backgroundMode.on('activate', self.onBackgroundModeActivated);
                $window.cordova.plugins.backgroundMode.on('deactivate', self.onBackgroundModeDeactivated);
            }

            self.meetingActiveElement = angular.element('#meeting-active')
                ? angular.element('#meeting-active')[0]
                : null;
            if (helperService.getIsRedesign()) {
                self.enableAutoHideHeaderControls();
            }

            if (meetingService.getIsSfuEnabled()) {
                avDeviceService.initDeviceChangeListener();

                if (helperService.shouldSidebarCollapse()) {
                    $rootScope.$broadcast('toggle-left-sidebar', 'closed');
                }

                logService.log('meetingActiveCtrl - attaching resize event listener');
                $window.$(window).on('resize', self.onWindowResize);
            }

            self.checkForThemedVBG();

            self.initCall();

            digest();
        }

        function initCall() {
            logService.log('meetingActiveCtrl - initCall');

            self.connectSocket() //only needed for MUX flow... just resolves if SFU
                .catch(function (err) {
                    logger.error('initCall', 'Error connecting socket', err);
                })
                .then(function () {
                    return self.determineMicAndCamAvailability();
                })
                .catch(function (err) {
                    logger.error('initCall', 'Error in determineMicAndCamAvailability', err);
                })
                .then(() => {
                    if (recordingService.shouldShowRecordingNotification()) {
                        recordingService.showRecordingNotificationForJoiningAttendee(() => {
                            self.startJoinFlow();
                        });
                    } else {
                        self.startJoinFlow();
                    }
                });
        }

        function startJoinFlow() {
            if (meetingService.getDeviceSelectionEnabled()) {
                logService.log('Device Selection dialog enabled');

                if (meetingService.shouldShowDeviceSelectionPreview()) {
                    $rootScope.$broadcast('show-modal', 'deviceSelection');
                    self.isDeviceSelectionModalOpen = true;
                    return;
                }

                if (meetingService.getVerticalJoinFlowEnabled()) {
                    if (meetingService.isDevicePreviewCacheDetected()) {
                        const audioMeetingState = storageService.get('inMeetingAudioState');
                        const videoMeetingState = storageService.get('inMeetingVideoState');
                        attendeeService.setIsAudioMuted(
                            audioMeetingState === null ? storageService.get('join-flow-audio-muted') : audioMeetingState
                        );
                        attendeeService.setIsVideoMuted(videoMeetingState === null ? true : videoMeetingState);
                    } else {
                        let joinAudioMuted = storageService.get('join-flow-audio-muted');

                        if (!meetingService.isAllowedByHostSecuritySettings('canUnmuteAudio')) {
                            joinAudioMuted = true;
                        }

                        //If skipping Vertical Join Flow, persist the A/V settings when joining meeting
                        attendeeService.setIsAudioMuted(joinAudioMuted);
                        //If skipping Vertical Join Flow, always turn webcam off
                        attendeeService.setIsVideoMuted(true);
                    }
                }

                logService.log('Skipping Device Selection dialog');
            }

            const hasCamera = avDeviceService.hasCamera();
            const hasMic = avDeviceService.hasMicrophone();

            attendeeService.setBroadcastOption({
                video: hasCamera,
                audio: hasMic
            });

            if (!hasCamera && !attendeeService.getIsVideoMuted()) {
                attendeeService.setIsVideoMuted(true);
            }

            if (!hasMic && !helperService.isMobile()) {
                logService.log('no mic on non-mobile, calling setAudioThroughPhone');
                connectivityService.setAudioThroughPhone(true, true);
            }

            const meetingType = meetingService.getMeetingType();
            if (meetingType === 'screenshare' || meetingType === 'videoconference') {
                self.setDeviceForConferenceOrScreenShare(meetingType);
                return;
            }

            const result = self.trySetDeviceForMeeting();
            if (!result) {
                $timeout(function () {
                    if (helperService.getIsRedesign()) {
                        $rootScope.$broadcast('show-modal', 'meetingSettings');
                    } else {
                        $rootScope.$broadcast('show-modal', 'micWebcamOptions');
                    }

                    logService.log('starting webrtc permission overlay before device preview');

                    $rootScope.$broadcast('start-webrtc-prompt-overlay');
                }, 1000);
            }
        }

        function setDeviceForConferenceOrScreenShare(meetingType) {
            let audioThroughPhone = false;

            // Override with query string
            switch (helperService.getQueryParameter('audio')) {
                case 'computer':
                    connectivityService.setInitialAudioChoice('audio');
                    break;
                case 'phone':
                    connectivityService.setInitialAudioChoice('phone');
                    audioThroughPhone = true;
                    break;
                default:
                    analyticsWrapperService.eventTrack(meetingType + ' Meeting - Calling Without Audio');
                    connectivityService.setInitialAudioChoice('no-audio');
                    audioThroughPhone = true;
            }

            const skipVideoConfPreview =
                cookieService.get('skipVideoConfPreview') === 'true' ||
                cookieService.get('skipVideoConfPreview') === true;

            if (
                meetingType === 'videoconference' &&
                avDeviceService.hasCamera() &&
                !helperService.isMobile() &&
                !skipVideoConfPreview
            ) {
                const modalName = helperService.getIsRedesign() ? 'meetingSettings' : 'micWebcamOptions';
                $rootScope.$broadcast('show-modal', modalName);
            } else {
                //Poorly named, but this lets other services/ctrls know
                //if client is using computer or phone for audio,
                //and then initiates the verto call
                self._setDeviceForMeeting(audioThroughPhone);
            }
        }

        function trySetDeviceForMeeting() {
            if (
                helperService.getQueryParameter('audio') === 'phone' ||
                helperService.getQueryParameter('audio') === 'computer'
            ) {
                // Override audio selection if query string 'audio' is present
                self._setDeviceForMeeting(helperService.getQueryParameter('audio') === 'phone');
                return true;
            }

            if (
                helperService.isMobile() === true ||
                self.isReceivingOnly() === true ||
                (!avDeviceService.hasCamera() && !avDeviceService.hasMicrophone())
            ) {
                // If client is mobile, webinar receiving only, or has no mic and no cam
                // Start call without showing device preview modal
                self.broadcastEventToStartCall();
                return true;
            }

            if (storageService.get('using-phone-for-audio') !== null) {
                // Select previously stored audio selection
                self._setDeviceForMeeting(storageService.get('using-phone-for-audio'));
                return true;
            }

            if (!meetingService.isWebinar()) {
                if (helperService.isVideoRoomApplication()) {
                    connectivityService.setInitialAudioChoice('audio');
                    self._setDeviceForMeeting(false);
                    self.broadcastEventToStartCall();
                } else {
                    // Show audio selection modal
                    $rootScope.$broadcast('show-modal', 'chooseAudioOptions');
                }
                return true;
            }

            return false;
        }

        function isReceivingOnly() {
            return !!(meetingService.isWebinar() && !attendeeService.getIsHost() && !attendeeService.getIsPresenter());
        }

        function _setDeviceForMeeting(usingPhoneForAudio) {
            connectivityService.setAudioThroughPhone(usingPhoneForAudio);
            self.broadcastEventToStartCall();
        }

        function disconnectAudio(disconnected) {
            avDeviceService.setAudioDisconnected(disconnected);
            connectivityService.disconnectAudioInputAndOutput(disconnected);
        }

        function connectSocket() {
            var deferred = $q.defer();

            if (meetingService.getIsSfuEnabled()) {
                deferred.resolve();
                return deferred.promise;
            } else {
                return vertoService.connectFSSocket();
            }
        }

        function determineMicAndCamAvailability() {
            return avDeviceService.determineMicAndCamAvailability(true);
        }

        function broadcastEventToStartCall() {
            if (meetingService.getIsSfuEnabled()) {
                $rootScope.$broadcast('initiate-janus-call');
            } else {
                $rootScope.$broadcast('initiate-verto-call');
            }
        }

        //Called by chooseAudioOptions modal controller
        //
        //Clients will be prompted to select computer audio, telephone, or no audio
        //at the start of a meeting
        function _newOnUserAudioChoice(e, data) {
            logService.log('new-user-audio-choice ', data);

            switch (data) {
                case 'audio':
                    self._setDeviceForMeeting(false);
                    break;
                case 'phone':
                    self._setDeviceForMeeting(true);
                    break;
                case 'no-audio':
                    logService.log("User selected 'No Audio' as initial audio choice");
                    self._setDeviceForMeeting(true);
                    break;
            }
        }

        function onBackgroundModeActivated() {
            vertoService.setIsVertoFeedVisible(false);
        }

        function onBackgroundModeDeactivated() {
            if (self.shouldSetVertoFeedToVisible()) {
                vertoService.setIsVertoFeedVisible(true);
            }
        }

        function shouldSetVertoFeedToVisible() {
            return (
                (self.videoFeedCount > 0 || contentService.isContentPlaying()) && !self.mobileChatAttendeeTabsVisible
            );
        }

        function trackViewing() {
            try {
                var typeDesc = meetingService.isWebinar() ? 'Webinar' : 'Meeting';
                var userDesc = 'Attendee';
                if (attendeeService.getIsHost()) {
                    userDesc = 'Host';
                } else if (attendeeService.getIsPresenter() && meetingService.isWebinar()) {
                    userDesc = 'Presenter';
                }
                analyticsWrapperService.eventTrack('Meeting - Active View - ' + typeDesc + ' ' + userDesc);

                if (meetingService.getIsSfuEnabled()) {
                    //General event regardless of user type
                    analyticsWrapperService.eventTrack('Meeting - Active View', { sfuEvent: true });

                    //User specific
                    analyticsWrapperService.eventTrack('Meeting - Active View - ' + typeDesc + ' ' + userDesc, {
                        sfuEvent: true
                    });
                }
            } catch (err) {
                logger.error('trackViewing', 'Error tracking initial analytics', err);
            }
        }

        function onDemotedToAttendee(event) {
            customerSupportService.disableSnapEngageLiveSupportWidget();
        }

        function onPromotedToPresenter(event) {
            customerSupportService.enableSnapEngageLiveSupportWidget();
        }

        function onUpdateAuthData(event) {
            var params = {
                meetingCode: meetingService.getMeetingCode()
            };

            var loginData = attendeeService.getAttendeeSocketLoginData();

            var postData = {
                attendantId: loginData.attendantId,
                name: loginData.screenName,
                location: loginData.location,
                email: loginData.email,
                isHost: false
            };

            meetingAPIService.setNewAttendee(params, postData).then(
                function (attendee) {
                    logService.log('Token updated');

                    attendeeService.setToken(attendee.token);
                },
                function (err) {
                    logger.error('onUpdateAuthData', 'Token update error', err);
                }
            );
        }

        function onAnnotationSync(event) {
            self.syncHDVertoMediaTracks();
        }

        function setupSingleShareView() {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }

            if (self.shouldShowSingleWebcamShareLocalView()) {
                localStreamManagerService
                    .initLocalVideoTrack()
                    .then(function () {
                        self.updateStreamReference(
                            self.streamTypes.SINGLE_SHARE,
                            localStreamManagerService.currentLocalStream
                        );
                    })
                    .catch(function (err) {
                        logService.log('meetingActiveCtrl - setupSingleShareView - error:', err);
                    });
            }
        }

        function determineLocalTracksAndSetProperStream() {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }

            if (attendeeService.getIsVideoMuted()) {
                if (localStreamManagerService.isLocalVideoTrackActive()) {
                    localStreamManagerService.stopLocalVideoTrack();
                }
                self.setProperOneOnOneStream();
            } else {
                localStreamManagerService
                    .initLocalVideoTrack()
                    .then(self.setProperOneOnOneStream)
                    .catch(function (err) {
                        logService.log(err);
                    });
            }
        }

        function setProperOneOnOneStream() {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }

            var localStream = localStreamManagerService.currentLocalStream;
            var remoteStream = peerConnectionService.getRemoteStream();

            if (self.videoFeedCount == 2) {
                self.updateStreamReference(self.streamTypes.LOCAL, localStream);
            }

            if (self.videoFeedCount !== 2) {
                self.stopMedia(self.streamTypes.LOCAL);
            }

            digest();
        }

        function getFeedType() {
            //Determines which feed client should see
            //Possible types: 'verto', 'janus'
            var feedType = 'verto';

            if (meetingService.getIsSfuEnabled()) {
                feedType = 'janus';
            }

            return feedType;
        }

        function toggleMobileChatAttendeeTabs() {
            var newVisibility = !self.mobileChatAttendeeTabsVisible;

            self.mobileChatAttendeeTabsVisible = newVisibility;

            if (helperService.isMobile() && !helperService.isTablet()) {
                if (self.shouldSetVertoFeedToVisible()) {
                    vertoService.setIsVertoFeedVisible(true);
                } else {
                    vertoService.setIsVertoFeedVisible(false);
                }
            }

            digest();
        }

        function onMobileWebinarAttendeeQAPromptVisible(e, visible) {
            self.mobileWebinarAttendeeQAPromptVisible = visible;
            digest();
        }

        function onDynamicVBWEnabled(e, data) {
            logService.log('onDynamicVBWEnabled ... ');
            if (data && data.enabled) {
                self.dynamicVBWEnabled = true;
            }
        }

        function onSingleShareEnabled(e, enabled) {
            self.singleShareEnabled = enabled;
        }

        function onScreenVideoCountChange(e, count) {
            logService.log('onScreenVideoCountChange: ', count);

            self.screenVideoCount = count;

            digest();
        }

        function onVideoFeedCountChange(e, count) {
            logService.log('onVideoFeedCountChange: ', count);

            if (!contentService.isContentPlaying()) {
                if (self.videoFeedCount === 0 && count > 0) {
                    //Going from 0 to 1+ webcams

                    if (!self.mobileChatAttendeeTabsVisible) {
                        vertoService.setIsVertoFeedVisible(true);
                    }
                } else if (self.videoFeedCount > 0 && count === 0) {
                    //Going from 1+ to 0 webcams
                    vertoService.setIsVertoFeedVisible(false);
                }
            }

            self.videoFeedCount = count;

            if (self.hdScreenShareAllowed() && self.isScreenShareActive()) {
                self.syncHDVertoMediaTracks();
            }

            if (!helperService.getIsMeetingEnding()) {
                if (self.shouldShowSingleWebcamShareLocalView()) {
                    self.setupSingleShareView();
                } else if (self.singleShareStream) {
                    self.stopMedia(self.streamTypes.SINGLE_SHARE);
                }
            }

            if (self.dynamicVBWEnabled && !helperService.getIsMeetingEnding() && !helperService.isMobile()) {
                if (self.videoFeedCount > 0) {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), self.videoFeedCount);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(
                            contentService.isContentPlaying(),
                            self.videoFeedCount
                        )
                    );
                } else {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), 1);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(contentService.isContentPlaying(), 1)
                    );
                }
            }

            digest();
        }

        function shouldShowSingleWebcamShareLocalView() {
            return (
                self.videoFeedCount == 1 &&
                !attendeeService.getIsVideoMuted() &&
                !self.isContentPlaying &&
                self.singleShareEnabled &&
                !helperService.isMobile()
            );
        }

        function _onStartVoting(e, data) {
            self.isVoting = true;
            digest();
        }

        function _onStopVoting(e, data) {
            self.isVoting = false;
            digest();
        }

        function _onStartQandA(e, data) {
            self.isInQandA = true;
            digest();
        }

        function _onStopQandA(e, data) {
            self.isInQandA = false;
            digest();
        }

        function _onRecordingEvent(e, data) {
            self.isRecording = data.isRecording;

            self.updateHeaderMenuStyleWhenToggleRecording();
            digest();
        }

        function updateHeaderMenuStyleWhenToggleRecording() {
            if (self.meetingActiveElement && self.meetingActiveElement.classList) {
                var headerMenuNewClassName, headerMenuOldClassName;

                if (self.isPresenter()) {
                    if (self.isRecording) {
                        if (self.meetingActiveElement.classList.contains('controls-hidden-not-recording')) {
                            headerMenuOldClassName = 'controls-hidden-not-recording';
                            headerMenuNewClassName = 'controls-hidden-recording';
                        }
                    } else {
                        if (self.meetingActiveElement.classList.contains('controls-hidden-recording')) {
                            headerMenuOldClassName = 'controls-hidden-recording';
                            headerMenuNewClassName = 'controls-hidden-not-recording';
                        }
                    }
                } else {
                    if (self.isRecording) {
                        if (self.meetingActiveElement.classList.contains('controls-hidden-not-recording-attendee')) {
                            headerMenuOldClassName = 'controls-hidden-not-recording-attendee';
                            headerMenuNewClassName = 'controls-hidden-attendee';
                        }
                    } else {
                        if (self.meetingActiveElement.classList.contains('controls-hidden-attendee')) {
                            headerMenuOldClassName = 'controls-hidden-attendee';
                            headerMenuNewClassName = 'controls-hidden-not-recording-attendee';
                        }
                    }
                }

                if (headerMenuOldClassName) {
                    self.meetingActiveElement.classList.remove(headerMenuOldClassName);
                    self.meetingActiveElement.classList.add(headerMenuNewClassName);
                    self.adjustHeaderMenuPosition(headerMenuNewClassName);
                }
            }
        }

        function updateHeaderMenuStyleWhenFadeOutTimerFired() {
            if (self.meetingActiveElement && self.meetingActiveElement.classList) {
                var headerMenuNewClassName;

                if (self.isPresenter()) {
                    if (self.isRecording) {
                        headerMenuNewClassName = 'controls-hidden-recording';
                    } else {
                        headerMenuNewClassName = 'controls-hidden-not-recording';
                    }
                } else {
                    if (self.isRecording) {
                        headerMenuNewClassName = 'controls-hidden-attendee';
                    } else {
                        headerMenuNewClassName = 'controls-hidden-not-recording-attendee';
                    }
                }

                // we should not clear class list here, because we do it in cancelExistingTopBottomControlFadeOutTimer function
                self.meetingActiveElement.classList.add(headerMenuNewClassName);
                if (avDeviceService.isAudioDisconnected()) {
                    self.meetingActiveElement.classList.add('audio-disconnected');
                }
                self.adjustHeaderMenuPosition(headerMenuNewClassName);
            }
        }

        function adjustHeaderMenuPosition(headerMenuClassName) {
            // our header menu has several classes which sets different 'right' property
            // it depends on host/attendee, recording/not recording, direct branding/UB branding...
            // in case when any button in menu is hidden we need to adjust 'right' property
            // this case E2EE button can be hidden if user-pair is not available (host) or E2EE is not enabled (attendee)
            $window.$('#meeting-active.' + headerMenuClassName + ' .header-inner').removeClass('one-button-hidden');
            if ($window.$('#security.menu-icon').length === 0) {
                $window.$('#meeting-active.' + headerMenuClassName + ' .header-inner').addClass('one-button-hidden');
            }
        }

        function _onContentInitiating(e, data) {
            self.currentContentOwnerId = data.ownerID;

            digest();
        }

        function _onContentInitCancelled(e, data) {
            self.currentContentOwnerId = 0;

            digest();
        }

        function _onContentPlaying(e, data) {
            self.isContentPlaying = true;
            self.currentContentType = data.type;

            if (self.videoFeedCount === 0 && !self.mobileChatAttendeeTabsVisible) {
                vertoService.setIsVertoFeedVisible(true);
            }

            if (self.dynamicVBWEnabled && !helperService.getIsMeetingEnding() && !helperService.isMobile()) {
                if (self.videoFeedCount > 0) {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), self.videoFeedCount);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(
                            contentService.isContentPlaying(),
                            self.videoFeedCount
                        )
                    );
                } else {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), 1);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(contentService.isContentPlaying(), 1)
                    );
                }
            }

            if (self.isScreenShareActive()) {
                annotationService.setAnnotationPenDraggable();
            }

            digest();
        }

        function _onContentStopped(e, data) {
            self.isContentPlaying = false;
            self.currentContentOwnerId = 0;
            self.currentContentType = '';

            if (self.videoFeedCount === 0) {
                vertoService.setIsVertoFeedVisible(false);
            }

            if (self.shouldShowSingleWebcamShareLocalView()) {
                self.setupSingleShareView();
            }

            if (self.dynamicVBWEnabled && !helperService.getIsMeetingEnding() && !helperService.isMobile()) {
                if (self.videoFeedCount > 0) {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), self.videoFeedCount);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(
                            contentService.isContentPlaying(),
                            self.videoFeedCount
                        )
                    );
                } else {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), 1);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(contentService.isContentPlaying(), 1)
                    );
                }
            }

            if (!self.VDIRef.showContentsOnTopOfVideo) {
                self.cleanupAnnotationUiForVDI();
            }

            digest();
        }

        //TODO: Update all content data to be pulled from contentService
        function _onContentStatus(e, data) {
            if (data.state === 'running') {
                self.isContentPlaying = true;
                self.currentContentOwnerId = data.ownerID;
                self.currentContentType = data.type;

                if (self.videoFeedCount === 0 && !self.mobileChatAttendeeTabsVisible) {
                    vertoService.setIsVertoFeedVisible(true);
                }
            }

            if (data.state === 'stopped') {
                self.isContentPlaying = false;
                self.currentContentOwnerId = 0;
                self.currentContentType = '';

                if (self.videoFeedCount === 0) {
                    vertoService.setIsVertoFeedVisible(false);
                }
            }

            logService.log(
                'self.isContentPlaying: ',
                self.isContentPlaying + ' contentService.isContentPlaying:',
                contentService.isContentPlaying()
            );

            if (self.dynamicVBWEnabled && !helperService.getIsMeetingEnding() && !helperService.isMobile()) {
                if (self.videoFeedCount > 0) {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), self.videoFeedCount);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(
                            contentService.isContentPlaying(),
                            self.videoFeedCount
                        )
                    );
                } else {
                    localStreamManagerService.adjustConstraints(contentService.isContentPlaying(), 1);
                    vertoService.updateLocalVideoBandwidth(
                        localStreamManagerService.getAdjustedBitrate(contentService.isContentPlaying(), 1)
                    );
                }
            }

            if (self.isScreenShareActive()) {
                annotationService.setAnnotationPenDraggable();
            }

            digest();
        }

        function _onBrandInformation() {
            var data = meetingService.getBrandingInfo();

            self.inMeetingBackground = data.backgroundURL || self.defaultBackgroundPath;

            digest();
        }

        function onBannerHeightChanged(e, newHeight) {
            logService.log('New banner height:', newHeight);
            var height = parseInt(newHeight);

            //Size of header (which is fixed)
            //For redesign, header is an overlay so the 60px offset is no longer needed
            var offset = helperService.getIsRedesign() ? 0 : 60;

            if (!isNaN(height)) {
                self.headerOffset = height;
                self.bodyOffset = height + offset;
                self.mobileBodyOffset = height;
                digest();
            }
        }

        function onCanvasBannerHeightChanged(e, newHeight) {
            logService.log('Canvas Banner Height Changed:', newHeight);
            var height = parseInt(newHeight);
            if (!isNaN(height)) {
                self.canvasBannerHeight = height;
                digest();
            }
        }

        function onLoadingPopupStart() {
            self.isLoadingPopupOpen = true;
            digest();
        }

        function onLoadingPopupStop() {
            self.isLoadingPopupOpen = false;
            digest();
        }

        function onPhoneOnlyState(e, data) {
            self.phoneOnlyState = true;
            digest();
        }

        function digest() {
            helperService.delayedWebRTCRefresh();

            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function isFeedActive() {
            if (meetingService.getIsSfuEnabled()) {
                return self.videoRoomWebcamVisible;
            }

            if (helperService.isMobile()) {
                var permissions = vertoService.getMobilePermissions();

                //For iOS, hide feed when modal/alert is open
                if (helperService.getDevicePlatform() === 'iOS') {
                    if (promptService.isPromptOpen()) {
                        return false;
                    }
                }
            }

            if (meetingService.isWebinarAttendee() && !self.isOnAir()) {
                return false;
            }

            //TODO: If Q&A active, return true
            if (self.isInQandA) {
                if (helperService.isMobile()) {
                    return false;
                } else {
                    return true;
                }
            }

            //For mobile, we cannot overlay over video feed...
            //so if polling is active, we want feedActive to be false
            if (self.isVoting) {
                if (helperService.isMobile()) {
                    return false;
                } else {
                    return true;
                }
            }

            if (self.phoneOnlyState) {
                return false;
            }

            if (!self.isConferenceConnected()) {
                return false;
            }

            if (self.shouldShowSingleWebcamShareLocalView() && !self.isSingleShareFeedPlaying) {
                return false;
            }

            return self.isContentPlaying === true || self.videoFeedCount > 0;
        }

        function onNodeReconnected() {
            logService.log('meetingActiveCtrl - Node reconnected... syncing attendee state');

            var iceConnectionState, bwUp, bwDown;

            if (meetingService.getIsSfuEnabled()) {
                iceConnectionState = connectivityService.getLocalConnectivityState();

                //We aren't currently retrieving bw for sfu clients
                //but we still pass default bw values for backwards compatibility
                bwUp = -1;
                bwDown = -1;
            } else {
                iceConnectionState = vertoService.getIceConnectionState();
                bwUp = vertoService.getAttendeeUploadBandwidth();
                bwDown = vertoService.getAttendeeDownloadBandwidth();
            }

            socketService.send({
                message: 'attendee-socket-reconnected',
                data: {
                    email: attendeeService.getEmail(),
                    isAudioMuted: attendeeService.getIsAudioMuted(),
                    isVideoMuted: attendeeService.getIsVideoMuted(),
                    isVideoBlinded: attendeeService.getIsVideoBlinded(),
                    isAudioDeafed: attendeeService.getIsAudioDeafed(),
                    hasScreenVideo: self.isScreenVideo,
                    devicePermissions: avDeviceService.getDevicePermissions(),
                    connectivity: {
                        connectionType: connectivityService.getConnectionType(),
                        iceConnectionState: iceConnectionState,
                        bandwidth: {
                            up: bwUp,
                            down: bwDown
                        },
                        packetLoss: {
                            state: connectivityService.getOutboundPacketLossState(),
                            streams: connectivityService.getOutboundStreams()
                        }
                    },
                    broadcastOption: attendeeService.getBroadcastOption(),
                    audioPin: attendeeService.getAudioPin(),
                    switchedToPhone: connectivityService.getAudioThroughPhone(),
                    phoneMemberId: attendeeService.getPhoneMemberId()
                }
            });

            if (attendeeService.getIsWaitingForAudioUpdate()) {
                attendeeService.setIsWaitingForAudioUpdate(false);
            }

            if (attendeeService.getIsWaitingForVideoUpdate()) {
                attendeeService.setIsWaitingForVideoUpdate(false);
            }

            if (!self.fsConnectionCompleteReceived) {
                //Timeout needed to allow time for Meeting Server to update attendee FS states
                $timeout(function () {
                    logService.log(
                        'Node Reconnected - fs-connection-complete not yet received... retrieving from server'
                    );
                    socketService.send({
                        message: 'fs-connection-complete',
                        data: {},
                        callback: function (result) {
                            logService.log(
                                'Node Reconnected - result received from fs-connection-complete check',
                                result
                            );
                            if (result) {
                                //Broadcast so that all listeners across ctrls/services can complete their init flows
                                $rootScope.$broadcast('fs-connection-complete');
                            }
                        }
                    });
                }, 500);
            }

            if (meetingService.getEnableAudioDisconnect() && !connectivityService.getAudioThroughPhone()) {
                self.disconnectAudio(avDeviceService.isAudioDisconnected());
            }
        }

        //leaving these
        function onDevicePermissionUpdated() {
            digest();
        }

        function hasSideBar() {
            if (helperService.isVideoRoomApplication()) {
                return false;
            }

            if (!meetingService.isWebinar()) {
                return true;
            } else {
                //Webinars
                if (attendeeService.getIsPresenter()) {
                    return true;
                } else {
                    var webinarOptions = meetingService.getWebinarOptions();

                    var isOnAir = self.isOnAir();
                    var hasAttendeeList = meetingService.isAttendeeListVisibleToAttendees();
                    var hasChat = webinarOptions.showPublicChat;

                    return isOnAir && (hasAttendeeList || hasChat);
                }
            }
        }

        function onChangeMeetingContentOpacity(e, data) {
            self.meetingContentShouldBeTransparent = data;
            digest();
        }

        function contentShouldBeTransparent() {
            return self.meetingContentShouldBeTransparent;
        }

        function onUserCapabilityUpdated() {
            digest();
        }

        function isPresenter() {
            return attendeeService.getIsPresenter();
        }

        function isOnAir() {
            return meetingService.getIsOnAir();
        }

        function isConferenceConnected() {
            return connectivityService.getConferenceConnected();
        }

        function isWaitingRoomEnabled() {
            return self.isWebinar() && !self.isPresenter() && !self.isOnAir();
        }

        function isGreenRoomEnabled() {
            return self.isWebinar() && self.isPresenter() && !self.isOnAir();
        }

        // extracted in meeting.service.ts
        function isWebinar() {
            return meetingService.isWebinar();
        }

        function isPractice() {
            return meetingService.getIsPractice();
        }

        function onWebinarOptionsUpdated(e, data) {
            if (helperService.isMobile() && !helperService.isTablet()) {
                if (
                    data &&
                    data.webinarOptions &&
                    !data.webinarOptions.showAttendeeList &&
                    !data.webinarOptions.showPublicChat
                ) {
                    if (self.mobileChatAttendeeTabsVisible) {
                        self.toggleMobileChatAttendeeTabs();
                    }
                }
            }

            digest();
        }

        function isWebinarHost() {
            return self.isWebinar() && self.isHost == true;
        }

        function shouldShowAppCues() {
            return (
                (!self.isWebinar() || isWebinarHost()) &&
                !onboardingService.hasAppCuesStarted() &&
                !helperService.isVideoRoomApplication()
            );
        }

        function onFSConnectionComplete() {
            if (self.shouldShowAppCues()) {
                logService.log('Sending onboarding info to AppCues');
                var onboardingInfo = attendeeService.getOnboardingInfo();

                //appCuesIdentify will check onboardingInfo for correct properties
                //It will handle if onboardingInfo is null or empty
                onboardingService.appCuesIdentify(self.isHost, onboardingInfo);
                onboardingService.initListeners();
            }

            if (self.hdScreenShareAllowed()) {
                if (self.isScreenShareActive() && !self.isScreenShareOwner()) {
                    //When joining meeting and screenshare active, use HD by default.
                    //If HD call not connected, make call here
                    if (!vertoService.isHDScreenShareCallConnected()) {
                        self.startWaitForHDScreenShareConferenceCall(
                            'Joined meeting while screenshare running and 0 webcams being shared'
                        );
                    }

                    self.syncHDVertoMediaTracks();
                } else {
                    self.initFeedVisibility();
                }
            } else {
                self.initFeedVisibility();
            }

            if (connectivityService.getAudioThroughPhone()) {
                attendeeService.setAudioDeaf(true);
            } else {
                attendeeService.setAudioDeaf(false);
            }

            if (storageService.get('disconnected-audio') !== null) {
                var audioDisconnected = JSON.parse(storageService.get('disconnected-audio'));
                if (
                    audioDisconnected.meetingCode === meetingService.getMeetingCode() &&
                    storageService.get('using-phone-for-audio') === false
                ) {
                    self.disconnectAudio(audioDisconnected.disconnected);
                }
            }

            if (meetingService.getEnableAudioDisconnect() && !connectivityService.getAudioThroughPhone()) {
                self.disconnectAudio(avDeviceService.isAudioDisconnected());
            }

            if (!helperService.isVideoRoomApplication() && !avDeviceService.isAudioDisconnected()) {
                var attendeeList = attendeeListService.getAttendeeList();
                var hasRoomClient = false;
                attendeeList.forEach(function (att) {
                    if (att.uniteRoomsUserId) {
                        hasRoomClient = true;
                    }
                });

                if (hasRoomClient && meetingService.getEnableAudioDisconnect()) {
                    var hasShownNoAudioPromptForRoomConference = false;
                    var hasShownNoAudioPromptForRoomConferenceState = JSON.parse(
                        storageService.get('has-shown-no-audio-prompt-for-room-conference')
                    );

                    if (hasShownNoAudioPromptForRoomConferenceState) {
                        hasShownNoAudioPromptForRoomConference =
                            hasShownNoAudioPromptForRoomConferenceState.meetingCode === meetingService.getMeetingCode();
                    }

                    if (storageService.get('showNoAudioPrompt') !== false && !hasShownNoAudioPromptForRoomConference) {
                        self.showNoAudioPromptForRoomConference();
                    }
                }
            }

            self.allowedToTrackAudio = true;
            self.trackLocalAudioWhileMuted();
            self.fsConnectionCompleteReceived = true;

            digest();
        }

        function initFeedVisibility() {
            //When joining meeting, get initial value of marquee visibility
            //If visible, vBlind current user
            //
            //Need timeout to ensure the true state of feed visibility...
            $timeout(function () {
                var isVertoFeedVisible = self.shouldSetVertoFeedToVisible();
                logService.log('Initial check for feed visiblity:', isVertoFeedVisible);
                vertoService.setIsVertoFeedVisible(isVertoFeedVisible);
            }, 1000);
        }

        function toggleFullScreenWrapper() {
            self.toggleFullScreen();
        }

        function toggleFullScreen() {
            var docElement = $document[0];
            var bodyElement = docElement.body;

            var requestFullscreen =
                bodyElement.requestFullscreen ||
                bodyElement.webkitRequestFullscreen ||
                bodyElement.mozRequestFullScreen ||
                bodyElement.msRequestFullscreen;

            var exitFullscreen =
                docElement.exitFullscreen ||
                docElement.webkitExitFullscreen ||
                docElement.mozCancelFullScreen ||
                docElement.msExitFullscreen;

            //This was copied over to helperService.isFullScreen()
            //so other ctrls can check fullscreen state
            var hasFullScreen =
                docElement.fullscreenElement ||
                docElement.webkitFullscreenElement ||
                docElement.mozFullScreenElement ||
                docElement.msFullscreenElement;

            if (!requestFullscreen || !exitFullscreen) {
                return;
            }

            if (!hasFullScreen) {
                requestFullscreen.call(bodyElement);
            } else {
                exitFullscreen.call(docElement);
            }
        }

        function toggleExpansion() {
            self.isExpanded = !self.isExpanded;
            storageService.set('shouldExpand', self.isExpanded);
            canvasMonitoringService.setExpandedState(self.isExpanded);
            annotationService.clearCanvas();
            digest();
        }

        // extracted in content.service.ts
        function isScreenShareActive() {
            return contentService.getIsScreenShareActive();
        }

        // extracted in content.service.ts
        function isVideoShareActive() {
            return contentService.getIsVideoShareActive();
        }

        function isScreenShareOwner() {
            return contentService.getContentOwner() === attendeeService.getAttendantId();
        }

        function onSfuScreenVideoState(e, data) {
            self.isScreenVideo = (data && data.value) || false;
            digest();
        }

        function onScreenShareStarted() {
            if (self.isScreenShareOwner()) {
                var screenShareResolution = vertoService.getScreenShareResolution();
                logService.log(
                    'ScreenShare resolution: ' + screenShareResolution.width + 'x' + screenShareResolution.height
                );

                sendAnnotationDetails();

                if (!contentService.getIsFilePlay()) {
                    self.checkSpaceBetweenScreenshareBtns();
                }
            } else {
                if (annotationService.getIsAnnotationEnabled()) {
                    self.shouldShowAnnotationButton = true;
                    analyticsWrapperService.eventTrack('Meeting - Annotation - Button appears for user', {
                        category: 'Annotation',
                        attendee: attendeeService.getEmail()
                    });
                }
            }

            if (self.hdScreenShareAllowed() && !self.isScreenShareOwner()) {
                if (!vertoService.isHDScreenShareCallConnected()) {
                    self.startWaitForHDScreenShareConferenceCall('ScreenShare started');
                }

                self.syncHDVertoMediaTracks();
            }
        }

        function showNoAudioPromptForRoomConference() {
            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            $window.swal(
                {
                    title:
                        closeButtonHtml +
                        localizationService.translate('ATTENDEE_LIST.DIALOG.JOINING_FROM_CONFERENCE_ROOM_TITLE'),
                    text: localizationService.translate('ATTENDEE_LIST.DIALOG.JOINING_FROM_CONFERENCE_ROOM_PROMPT'),
                    showCancelButton: true,
                    cancelButtonText: localizationService.translate(
                        'ATTENDEE_LIST.DIALOG.JOINING_FROM_CONFERENCE_ROOM_CONFIRM'
                    ),
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate(
                        'ATTENDEE_LIST.DIALOG.JOINING_FROM_CONFERENCE_ROOM_CANCEL'
                    ),
                    closeOnConfirm: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/info.svg',
                    customClass: 'audio-disconnect-modal auto-size'
                },
                function (confirm) {
                    storageService.set(
                        'has-shown-no-audio-prompt-for-room-conference',
                        JSON.stringify({ meetingCode: meetingService.getMeetingCode() })
                    );
                    if (!confirm) {
                        connectivityService.setAudioThroughPhone(false, true);
                        self.disconnectAudio(true);
                    }
                    footer.remove();
                }
            );

            let footer = document.createElement('p');
            footer.className = 'sweet-alert-footer';
            footer.innerHTML = localizationService.translate('ATTENDEE_LIST.DIALOG.JOINING_FROM_CONFERENCE_ROOM_HINT');
            document.getElementsByClassName('sweet-alert')[0].appendChild(footer);
        }

        function onAddAttendee(e, data) {
            if (!helperService.isVideoRoomApplication()) {
                if (meetingService.getEnableAudioDisconnect() && data.uniteRoomsUserId) {
                    var hasShownNoAudioPromptForRoomConference = false;
                    var hasShownNoAudioPromptForRoomConferenceState = JSON.parse(
                        storageService.get('has-shown-no-audio-prompt-for-room-conference')
                    );

                    if (hasShownNoAudioPromptForRoomConferenceState) {
                        hasShownNoAudioPromptForRoomConference =
                            hasShownNoAudioPromptForRoomConferenceState.meetingCode === meetingService.getMeetingCode();
                    }

                    if (
                        storageService.get('showNoAudioPrompt') !== false &&
                        !hasShownNoAudioPromptForRoomConference &&
                        self.fsConnectionCompleteReceived &&
                        !avDeviceService.isAudioDisconnected()
                    ) {
                        self.showNoAudioPromptForRoomConference();
                    }
                }
            }
            sendAnnotationDetails();
        }

        function sendAnnotationDetails() {
            if (self.isScreenShareOwner()) {
                let screenShareType;
                if (helperService.isElectron() || helperService.isUniteApplication()) {
                    screenShareType = contentService.getScreenShareType();
                } else {
                    screenShareType = vertoService.getScreenShareType() || contentService.getScreenShareType();
                }

                const hostType =
                    helperService.isElectron() || helperService.isUniteApplication() ? 'electron' : 'browser';
                socketService.send({
                    message: 'sa-sharer-supports-annotation',
                    data: {
                        sharerSupportsAnnotation:
                            annotationService.getCanHostAnnotation() && !contentService.getIsSharingAppScreen(),
                        screenShareType: screenShareType + '-' + hostType
                    }
                });
            }
        }

        function onScreenShareEnded() {
            if (annotationService.getIsAnnotationEnabled()) {
                self.shouldShowAnnotationButton = false;
                self.annotationEnabledLocally = false;
            }
        }

        function onHDScreenShareConfCallConnected() {
            logService.log('HD ScreenShare conference connected');
        }

        function onHDScreenShareConfCallDisconnected() {
            logService.log('HD ScreenShare conference disconnected');
            self.setHDScreenShareAvailabilityFlag(false);
            self.syncHDVertoMediaTracks();
            digest();
        }

        //Fired when we receive 'add-member' event
        function onHDScreenShareFSConnectionComplete(e, data) {
            logService.log('HD ScreenShare FS connection complete');
            analyticsWrapperService.eventTrack('meeting - verto - HD ScreenShare conference call connected');

            if (!self.hdScreenShareEventListenersAdded) {
                //This will normally get set to true on the HD screenshare feed 'play' event...
                //But if we were unable to attach that event listener, we'll manually set it here (to maintain previous behavior)
                self.setHDScreenShareAvailabilityFlag(true);
                self.syncHDVertoMediaTracks();
            }

            if (data && data.hdScreenShareConfMemberId) {
                attendeeService.setHDScreenShareConfMemberId(data.hdScreenShareConfMemberId);
            }

            digest();
        }

        //We enable/disable media tracks when toggling between HD and MUX feeds...
        //This function keeps everything synced so user doesn't encounter feed with disabled track.
        function syncHDVertoMediaTracks() {
            if (meetingService.getIsSfuEnabled()) {
                return;
            }

            var isHDVisible = false;

            if (helperService.browserHasWebRTC() && self.isScreenShareActive() && self.isHDScreenShareAvailable) {
                isHDVisible = self.videoFeedCount === 0 || self.isInFullScreenMode;
                if (self.annotationEnabledLocally) {
                    isHDVisible = true;
                }
            }

            if (annotationService.getIsAnnotationEnabled() && !annotationService.getIsSuspended()) {
                if (isHDVisible) {
                    if (self.annotationEnabledLocally) {
                        annotationService.attachListeners();
                    } else {
                        annotationService.removeListeners();
                    }
                } else {
                    annotationService.removeListeners();
                }
            } else if (annotationService.getIsAnnotationEnabled() && annotationService.getIsSuspended()) {
                isHDVisible = self.videoFeedCount === 0 || self.isInFullScreenMode;
            }

            vertoService.setHDScreenShareFeedVisible(isHDVisible);
            digest();
        }

        function shouldShowHDScreenShareFeed() {
            if (!helperService.browserHasWebRTC() || meetingService.getIsSfuEnabled()) {
                return false;
            }

            if (self.isScreenShareActive() && self.isHDScreenShareAvailable) {
                var track;

                try {
                    track = vertoService.getHDScreenShareCall().rtc.remoteStream.getVideoTracks()[0];
                } catch (e) {}

                if (track) {
                    return track.enabled;
                }
            }

            return false;
        }

        function startWaitForHDScreenShareConferenceCall(reason) {
            logService.log(reason + '... Waiting for HD ScreenShare Conference call');

            self.initHDScreenShareEventListeners();

            vertoService.callHDScreenShareConference();
            $rootScope.$broadcast('hd-screenshare-conf-call-connecting');
        }

        function initHDScreenShareEventListeners() {
            if (!self.hdScreenShareEventListenersAdded) {
                logService.log('Adding HD ScreenShare Video Event Listeners');

                try {
                    $window.$('#hdScreenShareFeed').on('playing', function () {
                        logService.log('HD ScreenShare Video Stream Started');
                        self.setHDScreenShareAvailabilityFlag(true);
                        self.showAnnotationLoadingAnimation = false;
                        self.syncHDVertoMediaTracks();

                        var isHDVisible =
                            self.videoFeedCount === 0 || self.isInFullScreenMode || self.annotationEnabledLocally;
                        if (!isHDVisible) {
                            vertoService.setHDScreenShareCallVideoBlind(true);
                        }
                    });

                    logService.log('Successfully added HD ScreenShare Video Event Listeners');
                    self.hdScreenShareEventListenersAdded = true;
                } catch (err) {
                    logService.log('Error adding HD ScreenShare Video Event Listeners:', err);

                    //Keep this flag false so we know to manually set availability flag to true on HD screenshare connection complete event
                    self.hdScreenShareEventListenersAdded = false;
                }
            }
        }

        function setHDScreenShareAvailabilityFlag(newAvailabilityValue) {
            logService.log('Setting HD ScreenShare availability to: ' + !!newAvailabilityValue);
            self.isHDScreenShareAvailable = !!newAvailabilityValue;
            self.initAnnotationBtnHighlighting();
            digest();
        }

        function hdScreenShareAllowed() {
            return (
                helperService.browserHasWebRTC() &&
                !meetingService.isWebinar() &&
                !helperService.isMobile() &&
                !meetingService.getIsSfuEnabled()
            );
        }

        function onHeaderControlHideState(ev, data) {
            if (!helperService.getIsRedesign()) {
                return;
            }

            //disableAutoHide can be called for multiple reasons.
            //We only want to re-enable auto-hide if all of the reasons have been cleared.
            //
            //For example, when both AppCues tooltips and a popover are visible, we disable auto-hide for these two separate reasons.
            //If only one of those closes, we still want auto-hide disabled.
            //Once both are closed, we can re-enable auto-hide.

            if (data && !data.enable) {
                if (data.reason && !self.autoHideDisabledReasons[data.reason]) {
                    self.autoHideDisabledReasons[data.reason] = true;
                }

                self.disableAutoHideHeaderControls();
            } else {
                if (data.reason && self.autoHideDisabledReasons[data.reason]) {
                    delete self.autoHideDisabledReasons[data.reason];
                }

                self.enableAutoHideHeaderControls();
            }
        }

        function enableAutoHideHeaderControls() {
            if (Object.keys(self.autoHideDisabledReasons).length === 0 && !self.autoHideEventListenerEnabled) {
                logger.log('enableAutoHideHeaderControls', 'enabling header control auto-hide');
                self.autoHideEventListenerEnabled = true;
                $window.addEventListener('mousemove', self.mouseMoveHandlerForTopBottomControl);

                //Initially enable the auto-hide without waiting for mousemove
                self.mouseMoveHandlerForTopBottomControl();
            }
        }

        function disableAutoHideHeaderControls() {
            if (self.autoHideEventListenerEnabled) {
                logger.log('disableAutoHideHeaderControls', 'disabling header control auto-hide');
                $window.removeEventListener('mousemove', self.mouseMoveHandlerForTopBottomControl);
                self.autoHideEventListenerEnabled = false;
                self.cancelExistingTopBottomControlFadeOutTimer();
            }
        }

        function mouseMoveHandlerForTopBottomControl(ev) {
            if (
                ev &&
                ($window.$(ev.target).parents('#sidebar-left').length ||
                    $window.$(ev.target).hasClass('tooltip') ||
                    $window.$(ev.target).parents('.tooltip').length)
            ) {
                return;
            }
            if (!self.isInFullScreenMode) {
                if (!self.showingTopBottomControl) {
                    self.showingTopBottomControl = true;
                    $rootScope.$broadcast('showing-top-bottom-controls', true);
                }
                self.cancelExistingTopBottomControlFadeOutTimer();
                self.fadeOutTopBottomControlTimer = $timeout(function () {
                    self.updateHeaderMenuStyleWhenFadeOutTimerFired();
                    if (self.showingTopBottomControl) {
                        self.showingTopBottomControl = false;
                        $rootScope.$broadcast('showing-top-bottom-controls', false);
                    }
                }, self.headerFadeOutDuration);
            }
        }

        function cancelExistingTopBottomControlFadeOutTimer() {
            $timeout.cancel(self.fadeOutTopBottomControlTimer);
            self.fadeOutTopBottomControlTimer = null;
            if (self.meetingActiveElement && self.meetingActiveElement.classList) {
                self.meetingActiveElement.classList.remove(
                    'controls-hidden-recording',
                    'controls-hidden-not-recording',
                    'controls-hidden-attendee',
                    'controls-hidden-not-recording-attendee',
                    'one-button-hidden',
                    'audio-disconnected'
                );
            }
        }

        function mouseMoveHandler(ev) {
            self.meetingActiveElement.classList.add('visible');
            if (self.fadeOutHeaderBarTimer) {
                $timeout.cancel(self.fadeOutHeaderBarTimer);
                self.fadeOutHeaderBarTimer = null;
            }
            //only trigger auto hide if mouse event target is not part of header hierarchy
            if (!$window.$(ev.target).parents('header#header').length) {
                self.fadeOutHeaderBarTimer = $timeout(function () {
                    self.meetingActiveElement.classList.remove('visible');
                }, self.headerFadeOutDuration);
            }
            digest();
        }

        function onFullScreenChange(res) {
            if (!self.isInFullScreenMode) {
                self.sideBarVisibleBeforeFullscreen = helperService.isLeftSidebarVisible();
            }
            annotationService.resetButtonLocation();
            self.isInFullScreenMode = !self.isInFullScreenMode;
            canvasMonitoringService.setFullScreenState(self.isInFullScreenMode);

            //Fullscreen toggled while screenshare active
            if (self.hdScreenShareAllowed() && self.isScreenShareActive() && !self.isScreenShareOwner()) {
                if (self.isInFullScreenMode && !vertoService.isHDScreenShareCallConnected()) {
                    self.startWaitForHDScreenShareConferenceCall('Fullscreen toggled while screenshare active');
                }

                self.syncHDVertoMediaTracks();
            }

            //new fullscreen flow for header bar and side bar
            self.meetingActiveElement = angular.element('#meeting-active')[0];

            if (self.isInFullScreenMode) {
                //set up timer to deal with showing header bar when mouse move
                //and hiding header bar after a 3 seconds timeout
                $timeout(function () {
                    self.adjustSideBarLeftOffsetBasedOnWidth();
                    $rootScope.$broadcast('toggle-left-sidebar', 'closed');
                }, 500);
                $window.addEventListener('mousemove', mouseMoveHandler);
                self.cancelExistingTopBottomControlFadeOutTimer();
            } else {
                if (self.sideBarVisibleBeforeFullscreen) {
                    $rootScope.$broadcast('toggle-left-sidebar', 'open');
                } else {
                    self.adjustSideBarLeftOffsetBasedOnWidth();
                    $rootScope.$broadcast('toggle-left-sidebar', 'closed');
                }
                $window.removeEventListener('mousemove', mouseMoveHandler);
                self.meetingActiveElement.classList.remove('visible');
            }

            digest();
        }

        function adjustSideBarLeftOffsetBasedOnWidth() {
            var sideBarElement = angular.element('#sidebar-left')[0];
            var sideBarElementComputedWidth = $window.getComputedStyle(sideBarElement, null).getPropertyValue('width');
            var width = sideBarElementComputedWidth ? sideBarElementComputedWidth : '300px';
            sideBarElement.style.left = '-' + width;
        }

        function onSideBarSwipeLeft() {
            if (!helperService.isTablet() || !self.hasSideBar() || helperService.isVideoZoomed) {
                return;
            }

            self.adjustSideBarLeftOffsetBasedOnWidth();

            $rootScope.$broadcast('toggle-left-sidebar', 'closed');

            helperService.delayedWebRTCRefresh();
        }

        function onSideBarSwipeRight() {
            if (!helperService.isTablet() || !self.hasSideBar() || helperService.isVideoZoomed) {
                return;
            }

            var sideBarElement = angular.element('#sidebar-left')[0];
            sideBarElement.style.left = '0px';

            $rootScope.$broadcast('toggle-left-sidebar', 'open');

            helperService.delayedWebRTCRefresh();
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('deviceSelection') !== -1) {
                self.isDeviceSelectionModalOpen = false;
            }

            digest();
        }

        function onShowHideFeatureFlags() {
            self.showingFeatureFlags = !self.showingFeatureFlags;
            console.info('changing feature flags=' + self.showingFeatureFlags);
            digest();
        }

        function autoHideHeader() {
            if (helperService.isMobile()) {
                return false;
            }

            if (self.isInFullScreenMode) {
                return true;
            }

            if (self.isScreenShareOnlyConf || self.isVideoOnlyConf) {
                return self.isConferenceConnected();
            }
            return false;
        }

        function isVideoOverlappingHeader() {
            var deviceType = helperService.getDeviceType();
            var confElementPosition;

            try {
                confElementPosition = $window.$('#conference').position();
            } catch (e) {}

            if (deviceType === 'iPhone') {
                return confElementPosition !== undefined && confElementPosition.left < 0; //Canvas overlaps left-hand menu
            } else if (deviceType === 'iPad') {
                return confElementPosition !== undefined && confElementPosition.top < 0; //Canvas overlaps top-hand menu
            }

            return false;
        }

        function onVertoCallCompleted() {
            logService.log('meetingActiveCtrl - onVertoCallCompleted');

            if (self.shouldShowSingleWebcamShareLocalView()) {
                self.setupSingleShareView();
            }
        }

        function updateStreamReference(streamName, newVal) {
            //Stream already playing
            if (self[streamName] && newVal && self[streamName].id === newVal.id && self[streamName].active) {
                if (attendeeService.getIsWaitingForVideoUpdate()) {
                    attendeeService.setIsWaitingForVideoUpdate(false);
                }

                //In some disconnect cases, local video will show black feed even if stream is active...
                //calling load() will reset the media element and allow the video to start playing again
                self.reloadMedia(streamName);

                return;
            }

            self.clearStreamReference(streamName);

            self.attachLoadMediaListener(streamName, function () {
                self.playMedia(streamName);
            });

            //Empty timeout is so the stream gets updated at the end of a digest cycle
            $timeout(function () {
                self[streamName] = newVal;
            });
        }

        function clearStreamReference(streamName) {
            self[streamName] = undefined;

            var element = self.getStreamElement(streamName);
            if (element) {
                element.src = undefined;
                element.srcObject = undefined;
            }

            digest();
        }

        function getStreamElement(streamType) {
            var element;

            try {
                switch (streamType) {
                    case self.streamTypes.SINGLE_SHARE:
                        element = $window.$('#single-share-videoFeed')[0];
                        break;
                    case self.streamTypes.LOCAL:
                        element = $window.$('#local-feed-view')[0];
                        break;
                }
            } catch (e) {
                logService.log('Unable to retrieve feed element:', e);
            }

            return element;
        }

        function attachLoadMediaListener(streamType, cb) {
            var element = self.getStreamElement(streamType);

            var onMediaLoaded = function () {
                element.removeEventListener('loadeddata', onMediaLoaded);
                if (cb) {
                    cb();
                }
            };

            if (element) {
                element.addEventListener('loadeddata', onMediaLoaded);
            }
        }

        function reloadMedia(streamType) {
            var element = self.getStreamElement(streamType);

            if (element && element.load && element.play) {
                element.load();
                element.play();
            }
        }

        function playMedia(streamType) {
            var element = self.getStreamElement(streamType);

            if (element && element.play) {
                //Return if media already playing
                if (!element.paused) {
                    self.completeMediaPlayMode(streamType);
                    return;
                }

                element
                    .play()
                    .then(function () {
                        self.completeMediaPlayMode(streamType);
                    })
                    .catch(function (err) {
                        logService.log('Stream type: ' + streamType + ', Error playing media:', err);
                        self.completeMediaPlayMode(streamType);
                    });
            } else {
                //This case shouldn't occur
                //But if it does, this will prevent the webcam button from staying disabled
                logService.log('Stream type: ' + streamType + ', Element does not have play function');
                self.completeMediaPlayMode(streamType);
            }
        }

        function completeMediaPlayMode(streamType) {
            if (streamType === self.streamTypes.SINGLE_SHARE) {
                self.isSingleShareFeedPlaying = true;
            }

            attendeeService.setIsWaitingForVideoUpdate(false);
            digest();
        }

        function stopMedia(streamType) {
            switch (streamType) {
                case self.streamTypes.SINGLE_SHARE:
                    self.singleShareStream = undefined;
                    self.isSingleShareFeedPlaying = false;
                    break;
                case self.streamTypes.LOCAL:
                    self.currentStream = undefined;
                    break;
            }

            digest();
        }

        function onUpdateMeetingActiveFeed() {
            if (
                !meetingService.getIsSfuEnabled() &&
                self.shouldShowSingleWebcamShareLocalView() &&
                !attendeeService.getIsVideoMuted()
            ) {
                //Wait for playMedia() to set 'waiting-for-video-update' back to false
            } else {
                attendeeService.setIsWaitingForVideoUpdate(false);
            }

            digest();
        }

        function onVideoRoomWebcamsVisible(e, webcamsVisible) {
            if (meetingService.getIsSfuEnabled()) {
                self.videoRoomWebcamVisible = !!webcamsVisible;
                digest();
            }
        }

        function getIconForMuteIndicator() {
            var filename = 'mic-off';

            if (connectivityService.getAudioThroughPhone()) {
                if (
                    !connectivityService.getConferenceConnected() ||
                    (attendeeService.getIsPhonePaired() && attendeeService.getIsAudioMuted())
                ) {
                    filename = 'phone-off';
                }
            }

            if (avDeviceService.isAudioDisconnected()) {
                filename = 'no-audio';
            }

            return '/img/redesign/icons/footer_icons/' + filename + '.svg';
        }

        function getTextForMuteIndicator() {
            var mutedIndicatorText = localizationService.translate('MAIN.YOU_ARE_MUTED');
            if (self.isInCompactMode) {
                mutedIndicatorText = localizationService.translate('HEADER.MUTED');
            }

            if (avDeviceService.isAudioDisconnected()) {
                mutedIndicatorText = localizationService.translate('HEADER.SETTINGS.DISCONNECT_AUDIO');
            }

            return mutedIndicatorText;
        }

        function onPhoneStateUpdated() {
            self.sendTelephoneStateToServer();

            var usingPhoneForAudio = connectivityService.getAudioThroughPhone();
            var hideDialInInformation = helperService.getQueryParameter('diiv') === 'hidden';

            if (
                usingPhoneForAudio &&
                connectivityService.getInitialAudioChoice() !== 'no-audio' &&
                !hideDialInInformation
            ) {
                $rootScope.$broadcast('show-modal', 'dialInInformation');
            }

            if (!usingPhoneForAudio && attendeeService.getIsPhonePaired()) {
                socketService.send({ message: 'unpair-phone-caller' });
            }
        }

        function sendTelephoneStateToServer() {
            if (connectivityService.getAudioThroughPhone()) {
                socketService.send({
                    message: 'switched-audio',
                    data: { type: 'telephone' }
                });
            } else {
                socketService.send({
                    message: 'switched-audio',
                    data: { type: 'microphone' }
                });
            }
        }

        function onActiveTrackEnded(e, track) {
            if (!track) {
                logger.log('onActiveTrackEnded', 'Media Track ended unexpectedly, but no track info was provided');
                return;
            }

            const mediaType = track.kind; //'audio' or 'video'

            if (!self.inProcessDevice) {
                self.inProcessDevice = mediaType;
            } else {
                self.queuedDeviceType = mediaType;
                logger.log('onActiveTrackEnded', 'Possible disconnect of combined device type.');
                analyticsWrapperService.eventTrack('Meeting - Media Tracks - Queuing device type ' + mediaType);
                return;
            }

            // General analytics event (regardless of media type)
            analyticsWrapperService.eventTrack('Meeting - Media Tracks - Ended unexpectedly');

            if (mediaType === 'audio') {
                analyticsWrapperService.eventTrack('Meeting - Media Tracks - Audio Track Ended unexpectedly');
                self.disconnectedMicDevice = avDeviceService.getCurrentlySelectedMic();
            } else if (mediaType === 'video') {
                analyticsWrapperService.eventTrack('Meeting - Media Tracks - Video Track Ended unexpectedly');
                self.disconnectedWebcamDevice = avDeviceService.getCurrentlySelectedWebcam();
                if (meetingService.getIsSfuEnabled()) {
                    $rootScope.$broadcast('stop-sfu-videopublish');
                } else {
                    logger.log('onActiveTrackEnded', 'MCU not supporting webcam reconnect flow');
                    self.finishReconnectFlow();
                    return;
                }
            } else {
                return;
            }

            avDeviceService
                .checkIfAVDevicePermissionsGranted()
                .then(function () {
                    var devicePermissions = avDeviceService.getDevicePermissions();

                    if (!devicePermissions.audioAllowed) {
                        self.promptUserAboutDeviceReconnection(mediaType, true);
                    } else {
                        const lastConnectedMic = avDeviceService.getCurrentlySelectedMic();
                        let supressMicDisconnectModal = false;
                        if (lastConnectedMic && lastConnectedMic.deviceId && lastConnectedMic.deviceId === 'default') {
                            if (avDeviceService.getAllPhysicalMicDevices().length > 1) {
                                //supress mic disconnect/reconnect modal because system will automatically trigger mic switch
                                //if default system device is selected
                                supressMicDisconnectModal = true;
                                self.finishReconnectFlow();
                            }
                        }
                        if (mediaType !== 'audio' || !supressMicDisconnectModal) {
                            self.promptUserAboutDeviceReconnection(mediaType, true);
                        }
                    }
                })
                .catch(function (err) {
                    logger.log('onActiveTrackEnded', 'Unable to check if AV Device permissions granted', err);
                    avDeviceService.startWebrtcPromptOverlay();
                });

            if (mediaType === 'audio') {
                self.sendAudioDeviceConnectionStateToServer(false);
            }
        }

        function sendAudioDeviceConnectionStateToServer(audioConnected) {
            socketService.send({
                message: 'attendee-device-connections-updated',
                data: {
                    deviceConnections: {
                        audioConnected: audioConnected
                    }
                }
            });
        }

        function promptUserAboutDeviceReconnection(mediaType, firstAttempt) {
            logger.log('promptUserAboutDeviceReconnection', 'prompting user for option to reconnect device');

            // ANYAM-103576 - pop-up appears on leave from meeting
            if (helperService.getIsMeetingEnding()) {
                logger.log('promptUserAboutDeviceReconnection', 'returning due to meeting ending');
                return;
            }

            let deviceType = 'device';
            let deviceId;
            let alertTitle;
            let alertMsg;
            let device;
            let deviceName;

            if (mediaType === 'audio') {
                deviceType = 'microphone';
                deviceId = storageService.get('audio-device');
                device = self.disconnectedMicDevice;

                alertTitle = firstAttempt
                    ? localizationService.translate(
                          'ATTENDEE_LIST.DIALOG.PROMPT_USER_ABOUT_DEVICE_RECONNECTION_DISCONNECTED_AUDIO'
                      )
                    : localizationService.translate(
                          'ATTENDEE_LIST.DIALOG.PROMPT_USER_ABOUT_DEVICE_RECONNECTION_PROBLEM_AUDIO'
                      );

                alertMsg = localizationService.translate(
                    'ATTENDEE_LIST.DIALOG.PROMPT_USER_ABOUT_DEVICE_RECONNECTION_MSG_AUDIO'
                );
            } else if (mediaType === 'video') {
                //The logic below is somewhat device-agnostic in case we want to handle video unplugging in the future
                deviceType = 'webcam';
                deviceId = storageService.get('video-device');
                device = self.disconnectedWebcamDevice;

                alertTitle = firstAttempt
                    ? localizationService.translate(
                          'ATTENDEE_LIST.DIALOG.PROMPT_USER_ABOUT_DEVICE_RECONNECTION_DISCONNECTED_VIDEO'
                      )
                    : localizationService.translate(
                          'ATTENDEE_LIST.DIALOG.PROMPT_USER_ABOUT_DEVICE_RECONNECTION_PROBLEM_VIDEO'
                      );

                alertMsg = localizationService.translate(
                    'ATTENDEE_LIST.DIALOG.PROMPT_USER_ABOUT_DEVICE_RECONNECTION_MSG_VIDEO'
                );
            } else {
                logger.log(
                    'promptUserAboutDeviceReconnection',
                    'Device reconnection flow does not support mediaType: ' + mediaType
                );
                return;
            }

            deviceName = device ? '<br><h4>' + device.label + '</h4><br>' : '';
            var swalOptions;
            if (helperService.getIsRedesign() === true) {
                var closeButtonHtmlDeviceReconnection =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                swalOptions = {
                    title: closeButtonHtmlDeviceReconnection + alertTitle,
                    text: deviceName + alertMsg,
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                    confirmButtonText: localizationService.translate('COMMON.RECONNECT'),
                    allowOutsideClick: false,
                    closeOnConfirm: false,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg'
                };
            } else {
                //TODO: REMOVE POST-REDESIGN
                swalOptions = {
                    title: alertTitle,
                    text: alertMsg,
                    type: 'warning',
                    showCancelButton: true,
                    showConfirmButton: true,
                    cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                    confirmButtonText: 'Reconnect',
                    allowOutsideClick: false,
                    closeOnConfirm: false
                };
            }

            avDeviceService.setIsPendingDeviceReconnect(true);

            $window.swal(swalOptions, function (reconnect) {
                if (reconnect) {
                    analyticsWrapperService.eventTrack(
                        'Meeting - Media Tracks - User chose to reconnect to same device'
                    );

                    //Show new alert showing a 'loading' UI to the user
                    //For this alert, only Cancel button will be available...
                    //
                    //If Cancel is clicked, we stop attempting check for the unplugged device's availability
                    //and make fallback connection to other available devices if they exist
                    self.showDeviceConnectingAlert(deviceType, function () {
                        //User clicked Cancel
                        self.cancelDeviceAvailabilityCheckInterval();
                        self.onUserCancelledReconnectionFlow(mediaType, deviceId);
                    });

                    //Cancel button for loading alert will only be enabled while checking for the device availability...
                    //If we know the device is available, disable the cancel button and continue with the connection attempt.
                    //
                    //This is to prevent cancelling in the middle of the getUserMedia flow

                    self.startDeviceAvailabilityCheckInterval(mediaType, deviceId, function (deviceIsAvailable) {
                        //Callback is called when device becomes available again, or if max tries reached

                        if (deviceIsAvailable) {
                            self.setSweetAlertBtnDisabledState('confirm', true);

                            self.attemptMediaTrackReconnection(mediaType, deviceId)
                                .then(function () {
                                    logger.log(
                                        'promptUserAboutDeviceReconnection',
                                        'Successfully reconnected to current ' + mediaType + ' device'
                                    );

                                    if (mediaType === 'audio') {
                                        self.disconnectedMicDevice = null;
                                        $rootScope.$broadcast('show-mic-unplugged-notification', {
                                            state: 'reconnected-current-device'
                                        });
                                        self.sendAudioDeviceConnectionStateToServer(true);
                                    } else if (mediaType === 'video') {
                                        self.disconnectedWebcamDevice = null;
                                        $rootScope.$broadcast('show-cam-unplugged-notification', {
                                            state: 'reconnected-current-device'
                                        });
                                    }
                                    self.finishReconnectFlow();
                                })
                                .catch(function (err) {
                                    logger.log(
                                        'promptUserAboutDeviceReconnection',
                                        'Unable to reconnect current ' + mediaType + ' device:',
                                        err
                                    );

                                    //If failed, re-show prompt
                                    //Timeout is to allow buffer between this current swal and the next
                                    $timeout(function () {
                                        self.promptUserAboutDeviceReconnection(mediaType, false);
                                    }, 500);
                                })
                                .finally(function () {
                                    $window.swal.close();
                                    self.setSweetAlertBtnDisabledState('confirm', false);
                                });
                        } else {
                            //Max tries reached... re-show prompt
                            //Timeout is to allow buffer between this current swal and the next
                            $timeout(function () {
                                self.promptUserAboutDeviceReconnection(mediaType, false);
                            }, 500);
                        }
                    });
                } else {
                    self.onUserCancelledReconnectionFlow(mediaType, deviceId);
                }
            });
        }

        function showDeviceConnectingAlert(deviceType, cb) {
            var alertTitle;
            if (deviceType === 'microphone') {
                alertTitle = localizationService.translate('ATTENDEE_LIST.DIALOG.RECONNECTION_MICROPHONE');
            } else if (deviceType === 'webcam') {
                alertTitle = localizationService.translate('ATTENDEE_LIST.DIALOG.RECONNECTION_WEBCAM');
            }
            var alertMsg = localizationService.translate('ATTENDEE_LIST.DIALOG.THIS_MAY_TAKE_FEW_SECONDS');
            var titleWithHTML =
                '<i id="custom-sa-spinner" class="zmdi zmdi-hc-2x zmdi-spinner zmdi-hc-spin"></i>' + alertTitle;

            if (helperService.getIsRedesign() === true) {
                var closeButtonHtmlConnectingAlert =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                //Swal callbacks are only allowed if a Confirm button is available...
                //So we include a Confirm button but label it as "Cancel" (due to product spec)
                $window.swal(
                    {
                        title: closeButtonHtmlConnectingAlert + titleWithHTML,
                        text: alertMsg,
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                        allowOutsideClick: false,
                        confirmButtonColor: '#8C8C8C', //im-gray
                        html: true
                    },
                    cb
                );
            } else {
                //TODO: REMOVE POST-REDESIGN
                //Swal callbacks are only allowed if a Confirm button is available...
                //So we include a Confirm button but label it as "Cancel" (due to product spec)
                $window.swal(
                    {
                        title: titleWithHTML,
                        text: alertMsg,
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'Cancel',
                        allowOutsideClick: false,
                        confirmButtonColor: '#8C8C8C', //im-gray
                        html: true
                    },
                    cb
                );
            }
        }

        function cancelDeviceAvailabilityCheckInterval() {
            if (self.deviceAvailabilityCheckInterval) {
                logService.log('onActiveTrackEnded - Cancelling device availability check interval');
                $interval.cancel(self.deviceAvailabilityCheckInterval);
                self.deviceAvailabilityCheckInterval = null;
            }
        }

        function onUserCancelledReconnectionFlow(mediaType, deviceId) {
            analyticsWrapperService.eventTrack('Meeting - Media Tracks - User chose not to reconnect to same device');

            self.connectToNextAvailableDevice(mediaType, deviceId)
                .then(function () {
                    logger.log(
                        'onUserCancelledReconnectionFlow',
                        'onActiveTrackEnded - Successfully connected to next available ' + mediaType + ' device'
                    );
                    if (mediaType === 'audio') {
                        $rootScope.$broadcast('show-mic-unplugged-notification', { state: 'connected-new-device' });
                        self.sendAudioDeviceConnectionStateToServer(true);
                    } else if (mediaType === 'video') {
                        $rootScope.$broadcast('show-cam-unplugged-notification', { state: 'connected-new-device' });
                    }
                    self.finishReconnectFlow();
                })
                .catch(function (err) {
                    logger.log(
                        'onUserCancelledReconnectionFlow',
                        'onActiveTrackEnded - Unable to connect to next available ' + mediaType + ' device:',
                        err
                    );

                    avDeviceService
                        .enumerateDevices()
                        .catch(function (err) {
                            logger.error(
                                'onUserCancelledReconnectionFlow',
                                'onActiveTrackEnded - Error enumerating devices',
                                err
                            );
                        })
                        .finally(function () {
                            if (mediaType === 'audio') {
                                for (var i = 0; i < avDeviceService.microphones.length; i++) {
                                    if (
                                        avDeviceService.microphones[i].deviceId === storageService.get('audio-device')
                                    ) {
                                        //Mic still exists, just has an error
                                        avDeviceService.setSfuDeviceError(
                                            storageService.get('audio-device'),
                                            err && err.message ? err.message : err
                                        );
                                        break;
                                    }
                                }

                                if (avDeviceService.microphones.length === 0) {
                                    avDeviceService.setHasMicrophone(false);
                                }

                                $rootScope.$broadcast('show-mic-unplugged-notification', {
                                    state: 'no-device-connected'
                                });
                            } else if (mediaType === 'video') {
                                for (var j = 0; j < avDeviceService.webcams.length; j++) {
                                    if (avDeviceService.webcams[j].deviceId === storageService.get('video-device')) {
                                        //Webcam still exists, just has an error
                                        avDeviceService.setSfuDeviceError(
                                            storageService.get('video-device'),
                                            err && err.message ? err.message : err
                                        );
                                        break;
                                    }
                                }

                                if (avDeviceService.webcams.length === 0) {
                                    avDeviceService.setHasCamera(false);
                                }

                                $rootScope.$broadcast('show-cam-unplugged-notification', {
                                    state: 'no-device-connected'
                                });
                            }

                            self.finishReconnectFlow();
                        });
                });
        }

        function startDeviceAvailabilityCheckInterval(mediaType, deviceId, cb) {
            if (self.deviceAvailabilityCheckInterval) {
                logger.log(
                    'startDeviceAvailabilityCheckInterval',
                    'onActiveTrackEnded - deviceAvailabilityCheckInterval already exists... returning'
                );
                return;
            }

            let mediaEnum;
            if (mediaType === 'audio') {
                mediaEnum = avDeviceService.deviceTypes.AUDIO_INPUT;
            } else if (mediaType === 'video') {
                mediaEnum = avDeviceService.deviceTypes.VIDEO_INPUT;
            }

            if (!mediaEnum || !deviceId) {
                logger.log(
                    'startDeviceAvailabilityCheckInterval',
                    'onActiveTrackEnded - invalid params for deviceAvailabilityCheckInterval... returning'
                );
                return;
            }

            logger.log(
                'startDeviceAvailabilityCheckInterval',
                'onActiveTrackEnded - Starting device ' + mediaType + ' availability check interval for:',
                deviceId
            );

            let count = 0;
            self.deviceAvailabilityCheckInterval = $interval(function () {
                count++;

                avDeviceService
                    .checkIfDeviceIsAvailable(mediaEnum, deviceId)
                    .then(function (deviceIsAvailable) {
                        if (deviceIsAvailable) {
                            logger.log(
                                'startDeviceAvailabilityCheckInterval',
                                'onActiveTrackEnded - Device is available'
                            );

                            self.cancelDeviceAvailabilityCheckInterval();

                            const delayBeforeReconnectingDevice = 1000;
                            logger.log(
                                'startDeviceAvailabilityCheckInterval',
                                'onActiveTrackEnded - Will reconnect device after ' +
                                    delayBeforeReconnectingDevice +
                                    'ms'
                            );
                            $timeout(function () {
                                executeCallback(true);
                            }, delayBeforeReconnectingDevice);
                        } else {
                            logger.log(
                                'startDeviceAvailabilityCheckInterval',
                                'onActiveTrackEnded - Device not available'
                            );

                            if (count === 5) {
                                logger.log('onActiveTrackEnded - Device availability check max tries reached');
                                self.cancelDeviceAvailabilityCheckInterval();
                                executeCallback(false);
                            }
                        }
                    })
                    .catch(function (err) {
                        logger.log(
                            'startDeviceAvailabilityCheckInterval',
                            'onActiveTrackEnded - Error checking device availability:',
                            err
                        );

                        if (count === 5) {
                            logger.log(
                                'startDeviceAvailabilityCheckInterval',
                                'onActiveTrackEnded - Device availability check max tries reached'
                            );
                            self.cancelDeviceAvailabilityCheckInterval();
                            executeCallback(false);
                        }
                    });
            }, 3000);

            function executeCallback(param) {
                if (cb) {
                    cb(param);
                }
            }
        }

        function setSweetAlertBtnDisabledState(btnClass, newDisabledState) {
            try {
                $window.$('.sa-button-container .' + btnClass).attr('disabled', newDisabledState);
            } catch (e) {
                logger.log('setSweetAlertBtnDisabledState', 'Error setting SweetAlert cancel button enabled state:', e);
            }
        }

        function attemptMediaTrackReconnection(mediaType, deviceId) {
            var deferred = $q.defer();

            if (!deviceId) {
                deferred.reject('Invalid deviceId: ' + deviceId);
            }

            if (mediaType === 'audio') {
                return self.attemptAudioTrackReconnection(deviceId);
            } else if (mediaType === 'video') {
                return self.attemptVideoTrackReconnection(deviceId);
            }

            deferred.reject('Invalid media type:' + mediaType);
            return deferred.promise;
        }

        function connectToNextAvailableDevice(mediaType, currentlyUsedDeviceId) {
            let deferred = $q.defer();

            logger.log(
                'connectToNextAvailableDevice',
                'onActiveTrackEnded - Will attempt connection for next available ' + mediaType + ' device'
            );

            avDeviceService
                .enumerateDevices()
                .then(function () {
                    let arrayToCheck, nextAvailableDeviceId;

                    if (mediaType === 'audio') {
                        arrayToCheck = avDeviceService.microphones;
                    } else if (mediaType === 'video') {
                        arrayToCheck = avDeviceService.webcams;
                    } else {
                        deferred.reject('Invalid mediaType: ' + mediaType);
                        return;
                    }

                    for (var i = 0; i < arrayToCheck.length; i++) {
                        if (arrayToCheck[i].deviceId !== currentlyUsedDeviceId || currentlyUsedDeviceId === 'default') {
                            nextAvailableDeviceId = arrayToCheck[i].deviceId;
                            break;
                        }
                    }

                    if (nextAvailableDeviceId) {
                        self.attemptMediaTrackReconnection(mediaType, nextAvailableDeviceId)
                            .then(function () {
                                deferred.resolve();
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    } else {
                        deferred.reject('No other devices available');
                    }
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function attemptAudioTrackReconnection(deviceId) {
            var deferred = $q.defer();

            logService.log('onActiveTrackEnded - Attempting to retrieve new stream for audio device:', deviceId);

            localStreamManagerService
                .initLocalAudioTrack(deviceId)
                .then(function () {
                    logService.log(
                        'onActiveTrackEnded - Successfully retrieved new stream for audio device:',
                        deviceId
                    );
                    storageService.set('audio-device', deviceId);
                    if (meetingService.getIsSfuEnabled()) {
                        $rootScope.$broadcast('sfu-audio-device-reconnection');
                    } else {
                        vertoService.setNewAudioInputSource(deviceId, localStreamManagerService.currentLocalAudioTrack);
                    }

                    deferred.resolve();
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function attemptVideoTrackReconnection(deviceId) {
            var deferred = $q.defer();

            logService.log('onActiveTrackEnded - Attempting to retrieve new stream for video device:', deviceId);

            localStreamManagerService
                .initLocalVideoTrack(deviceId)
                .then(function () {
                    logService.log(
                        'onActiveTrackEnded - Successfully retrieved new stream for video device:',
                        deviceId
                    );
                    storageService.set('video-device', deviceId);
                    if (meetingService.getIsSfuEnabled()) {
                        $rootScope.$broadcast('sfu-video-device-reconnection');
                    } else {
                        vertoService.setNewVideoInputSource(deviceId, localStreamManagerService.currentLocalVideoTrack);
                    }

                    deferred.resolve();
                })
                .catch(function (err) {
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        function finishReconnectFlow() {
            logger.log('finishReconnectFlow', 'Calling finishReconnectFlow() ...', self.queuedDeviceType);
            self.inProcessDevice = null;
            avDeviceService.setIsPendingDeviceReconnect(false);
            if (self.queuedDeviceType) {
                logger.log('finishReconnectFlow', 'onActiveTrackEnded - running queued device type');
                const dummyTrack = { kind: self.queuedDeviceType };
                self.queuedDeviceType = null;
                $timeout(function () {
                    self.onActiveTrackEnded('active-track-ended', dummyTrack);
                }, 500);
            }
        }

        function onClonedAudioStreamReady() {
            logService.log('talkingWhileMutedDetection - cloned audio stream ready');

            //Audio stream is usually ready before connection complete...
            //But its possible that a mic can be connected after already joining the meeting
            if (connectivityService.getConferenceConnected()) {
                self.trackLocalAudioWhileMuted();
            }
        }

        function onClonedAudioTrackEnded() {
            self.stopTrackingLocalAudio();
        }

        function canTrackLocalAudioWhileMuted() {
            if (
                !attendeeService.getIsAudioMuted() ||
                !self.allowedToTrackAudio ||
                helperService.isDefaultMutedStateNotificationVisible()
            ) {
                return false;
            }

            return true;
        }

        function trackLocalAudioWhileMuted() {
            if (!self.canTrackLocalAudioWhileMuted()) {
                return;
            }

            self.cancelRestartTrackLocalAudioWhileMutedTimeout();

            avDeviceService.trackStartStopTalking(
                localStreamManagerService.clonedAudioStream,
                function () {
                    //If talking for >1s, show alert
                    if (!self.talkingTimeoutWhileMuted) {
                        self.talkingTimeoutWhileMuted = $timeout(function () {
                            analyticsWrapperService.eventTrack('Meeting - Detected attendee talking while muted');
                            avDeviceService.untrackStartStopTalking(localStreamManagerService.clonedAudioStream);
                            self.cancelTalkingTimeoutWhileMuted();

                            self.restartTrackLocalAudioWhileMutedTimeout = $timeout(function () {
                                self.trackLocalAudioWhileMuted();
                            }, 60000); // 1 minute

                            if (self.canTrackLocalAudioWhileMuted()) {
                                $rootScope.$broadcast('talking-while-muted-detected');
                            }
                        }, 1000); // 1 second
                    }
                },
                function () {
                    self.cancelTalkingTimeoutWhileMuted();
                }
            );
        }

        function cancelTalkingTimeoutWhileMuted() {
            if (self.talkingTimeoutWhileMuted) {
                $timeout.cancel(self.talkingTimeoutWhileMuted);
                self.talkingTimeoutWhileMuted = null;
            }
        }

        function cancelRestartTrackLocalAudioWhileMutedTimeout() {
            if (self.restartTrackLocalAudioWhileMutedTimeout) {
                $timeout.cancel(self.restartTrackLocalAudioWhileMutedTimeout);
                self.restartTrackLocalAudioWhileMutedTimeout = null;
            }
        }

        function stopTrackingLocalAudio() {
            avDeviceService.untrackStartStopTalking(localStreamManagerService.clonedAudioStream);
            self.cancelTalkingTimeoutWhileMuted();
            self.cancelRestartTrackLocalAudioWhileMutedTimeout();
        }

        function onUpdateLocalAudioState() {
            if (attendeeService.getIsAudioMuted()) {
                self.trackLocalAudioWhileMuted();
            } else {
                self.stopTrackingLocalAudio();
            }
        }

        function onVertoCallAudioInputUpdated() {
            self.sendAudioDeviceConnectionStateToServer(true);
        }

        function isAudioMuted() {
            return (
                (attendeeService.getIsAudioMuted() &&
                    !connectivityService.getAudioThroughPhone() &&
                    connectivityService.getConferenceConnected()) ||
                (attendeeService.getIsPhonePaired() && attendeeService.getIsAudioMuted())
            );
        }

        // this is not used anymore. see headerCtrl's layoutControls.
        function isLayoutChangeAvailable() {
            var feedCount = self.videoFeedCount;

            //Screenshare or Fileshare
            if (contentService.isContentPlaying()) {
                //Screenshare owners do not see their own screenshare feed, so we dont increment feedCount in this case
                if (!self.isScreenShareActive() || !self.isScreenShareOwner()) {
                    feedCount++;
                }
            }

            //PIP Mode
            if (feedCount === 2 && !attendeeService.getIsVideoMuted()) {
                return false;
            }

            return self.isFeedActive() && feedCount > 1;
        }

        // this is not used anymore. see headerCtrl's layoutControls.
        function isLayoutChangeAvailableForLargeGalleryView() {
            var feedCount = self.videoFeedCount;

            //Screenshare or Fileshare
            if (contentService.isContentPlaying()) {
                //Screenshare owners do not see their own screenshare feed, so we dont increment feedCount in this case
                if (!self.isScreenShareActive() || !self.isScreenShareOwner()) {
                    feedCount++;
                }
            }

            //PIP Mode
            if (feedCount === 2 && !attendeeService.getIsVideoMuted()) {
                return false;
            }

            return (
                self.isFeedActive() &&
                (feedCount >= videoroomService.getNumberOfFeedsToEnableLGV() ||
                    videoroomService.isLayoutInLargeGalleryView())
            );
        }

        function onMuteStateUpdated(e, data) {
            if (
                !data.requester ||
                !data.action ||
                (!data.updatedAttendee && data.action !== 'muteAll') ||
                data.updatedAttendee === 'everyone'
            ) {
                return;
            }

            var requesterID = data.requester.id;
            var requesterName = data.requester.name;
            var updatedAttendeeID = 0;
            var updatedAttendeeName = '';

            if (data.action === 'muteAll') {
                updatedAttendeeName = localizationService.translate('COMMON.EVERYONE');
            } else if (data.updatedAttendee.isPhoneUser && !attendeeService.getIsPresenter()) {
                updatedAttendeeName = localizationService.translate('COMMON.PHONE_CALLER');
            } else if (data.updatedAttendee.isPhoneUser && attendeeService.getIsPresenter()) {
                updatedAttendeeID = data.updatedAttendee.id;
                updatedAttendeeName =
                    data.updatedAttendee.name +
                    (data.updatedAttendee.assignment > 0
                        ? ' (' + (parseInt(data.updatedAttendee.assignment) + 1) + ')'
                        : '');
            } else {
                updatedAttendeeID = data.updatedAttendee.id;
                updatedAttendeeName = data.updatedAttendee.name;
            }

            //Don't show notification if user mutes his/herself
            if (requesterID === updatedAttendeeID) {
                return;
            }

            //Toaster Notification
            var action = data.action === 'mute' || data.action === 'muteAll' ? 'muted' : 'unmuted';
            var message =
                action === 'muted'
                    ? localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.PERSON_MUTED', {
                          requester: requesterName,
                          name: updatedAttendeeName
                      })
                    : localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.PERSON_UNMUTED', {
                          requester: requesterName,
                          name: updatedAttendeeName
                      });

            notificationService.show(message, 'success');
        }

        function getDefaultBackgroundPath() {
            return brandingService.getBackgroundURL({ isWebinar: meetingService.isWebinar() });
        }

        function checkSpaceBetweenScreenshareBtns() {
            setTimeout(() => {
                try {
                    var title = $window.$('#screenShareCover .coverTitle');
                    if (title && title.offset()) {
                        var spaceBetweenTitleAndTopControls =
                            $window.$(window).width() -
                            $window.$('#right-menu').width() -
                            (title.offset().left + title.width());

                        if (!self.movePresenterCtrlBtnsToSecondRow && spaceBetweenTitleAndTopControls <= 8) {
                            self.movePresenterCtrlBtnsToSecondRow = true;
                            digest();
                        } else if (self.movePresenterCtrlBtnsToSecondRow && spaceBetweenTitleAndTopControls > 8) {
                            self.movePresenterCtrlBtnsToSecondRow = false;
                            digest();
                        }
                    }
                } catch (e) {
                    logger.error('checkSpaceBetweenScreenshareBtns', 'error', e);
                }
            }, 0);
        }

        function onWindowResize() {
            if (self.isScreenShareActive() && self.isScreenShareOwner()) {
                self.checkSpaceBetweenScreenshareBtns();
            }
            if (helperService.shouldSidebarCollapse()) {
                if (helperService.isLeftSidebarVisible()) {
                    if (helperService.getMinimizedSideBarClickedState()) {
                        $rootScope.$broadcast('toggle-left-sidebar', 'open');
                    } else {
                        $rootScope.$broadcast('toggle-left-sidebar', 'closed');
                    }
                }
            } else {
                helperService.setMinimizedSideBarClickedState(false);
                if (helperService.getSideBarClickedState() !== false) {
                    $rootScope.$broadcast('toggle-left-sidebar', 'open');
                }
            }
            annotationService.resetButtonLocation();
        }

        function onVisibilityChange() {
            var doc = $document[0];

            if (doc) {
                if (doc.hidden || doc.webkitHidden) {
                    if (self.isVideoShareActive() && self.isScreenShareOwner()) {
                        logService.log('App background detected while sharing video');

                        try {
                            $window.$('#videoroom-videos .remote.screen.fileplay.controls video')[0].pause();
                            notificationService.tryShowDesktopNotification(
                                localizationService.translate('SCREENSHARE.YOUR_VIDEO_HAS_BEEN_PAUSED')
                            );
                        } catch (e) {
                            logger.error('onVisibilityChange', 'Error trying to pause video playback', e);
                        }
                    }
                }
            }
        }

        function isLayoutActive(layoutName) {
            if (layoutName === videoroomService.layouts.GALLERY) {
                return videoroomService.getCurrentLayout() === videoroomService.layouts.GALLERY;
            } else if (layoutName === videoroomService.layouts.ALLHANDS) {
                return videoroomService.getCurrentLayout() === videoroomService.layouts.ALLHANDS;
            } else if (layoutName === videoroomService.layouts.SPOTLIGHT) {
                return videoroomService.getCurrentLayout() === videoroomService.layouts.SPOTLIGHT;
            } else {
                return false;
            }
        }

        function onAWVPaginationHover() {
            //Enable auto-hide after user hovers over button
            if (!self.shouldAutoHideAWVPagination) {
                self.shouldAutoHideAWVPagination = true;
            }
        }

        function enterAWVFromPagination() {
            analyticsWrapperService.eventTrack(
                'Meeting - User Clicked to Enter All Webcams View Layout From Pagination'
            );

            $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.ALLHANDS });
        }

        function exitAWVFromPagination() {
            analyticsWrapperService.eventTrack(
                'Meeting - User Clicked to Exit All Webcams View Layout From Pagination'
            );

            $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.getPreviousLayout() });
        }

        function onLayoutChangeControls(e, data) {
            Object.assign(self.layoutControls, data);
        }

        //This allows the "bounce in" animation for the Pagination arrow button
        //This should return true as soon as AWV becomes available, but it should only return true once
        //The timeout is to allow time for the animation to complete
        function shouldAWVPaginationBounceIn() {
            if (self.awvPaginationShownOnce) {
                return false;
            }

            if (self.layoutControls.allhands && !self.isLayoutActive('allhands')) {
                if (!self.awvPaginationShownOnce) {
                    if (!self.awvPaginationBounceInTimer) {
                        self.awvPaginationBounceInTimer = $timeout(function () {
                            self.awvPaginationShownOnce = true;
                        }, 2000);
                    }

                    return true;
                }
            }

            return false;
        }

        function onLayoutChanged(e, data) {
            if (!data) {
                logger.error('onLayoutChanged', 'Invalid params for onLayoutChanged', data);
                return;
            }

            if (data.newLayout === videoroomService.layouts.ALLHANDS) {
                self.showAWVBanner();
                notifyNodeAWVLayoutChange();
            } else if (data.previousLayout === videoroomService.layouts.ALLHANDS) {
                //If switching from AWV to any other layout, dismiss AWV banner
                $rootScope.$broadcast('canvas-banner-message-dismiss');
            }
        }

        function notifyNodeAWVLayoutChange() {
            socketService.send({
                message: 'awv-layout-activated',
                data: {}
            });
        }

        function showAWVBanner() {
            var awvBannerDismissed = JSON.parse(storageService.get('awv-banner-dismissed'));
            if (!awvBannerDismissed || awvBannerDismissed.meetingCode != meetingService.getMeetingCode()) {
                $rootScope.$broadcast('canvas-banner-message-show', {
                    header: localizationService.translate('BANNER_MESSAGES.AWV.BANNER_TITLE'),
                    content: localizationService.translate('BANNER_MESSAGES.AWV.BANNER_CONTENT'),
                    id: 'awv-banner'
                });
            }
        }

        function isThemedFeaturesEnabled() {
            return themedFeaturesService.getThemedFeaturesEnabled();
        }

        function onThemedFeaturesToggled() {
            self.checkForThemedVBG();
        }

        function checkForThemedVBG() {
            var curVBG = storageService.get('virtual-background-id');

            if (!themedFeaturesService.getThemedFeaturesEnabled() && curVBG && curVBG.startsWith('themed-bg')) {
                logService.log('Themed Features disabled, removing themed Virtual Background and defaulting to blur');
                storageService.set('virtual-background-id', 'blur');
                storageService.set('videoFilter', 'blur-bg');
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: curVBG,
                    newValue: 'blur-bg'
                });
            }
        }

        function verticalJoinFlowEnabled() {
            return meetingService.getVerticalJoinFlowEnabled();
        }

        function cleanupAnnotationUiForVDI() {
            if (colorPickerBounds !== null) {
                self.VDIRef.removeClipRect(colorPickerBounds);
                colorPickerBounds = null;
            }
        }

        function onCompactModeReceived(e, data) {
            self.isInCompactMode = data;
            if (data && annotationService.getIsInSession()) {
                self.toggleUserAnnotation();
            }
        }

        function onAnnotationContinue() {
            if (!annotationService.getIsInitiator() && annotationService.getIsLocalAnnotationEnabled()) {
                self.annotationEnabledLocally = true;
            }
        }
    }
]);
